// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

:root {
  --color-inherit: inherit;
  --color-current: currentColor;
  --color-transparent: transparent;
  --color-black: #000;
  --color-white: #fff;
  --color-ec-title: #121216;
  --color-ec-body: #3C3C42;
  --color-ec-light-black: #7F7F98;
  --color-ec-red: #FF3A52;
  --color-ec-red-bg: #FF3A521A;
  --color-ec-green: #009D68;
  --color-ec-draft: #3748FA;
  --color-ec-yellow: #E8A700;
  --color-ec-yellow-bg: #E8A7000D;
  --color-ec-table-stock: #F0EDFB;
  --color-ec-table-bg: #00000008;
  --color-ec-main-bg: #EEF0FF;
  --color-ec-primary: #7351FD;
  --color-ec-secondary: #7351FDCC;
  --color-ec-tertiary: #7351FD40;
  --color-ec-accent: #7351FD0D;
  --color-ec-border: #ebebeb;
  --color-ec-shadow: #00000014;
  --color-ec-modal: #00000008;
  --color-ec-placeholder: #9B9BB5;
  --color-ec-active: #F8F6FF;
  --color-ec-allText: #121216;
  --color-ec-allBg: #1212161A;
  --color-ec-liveText: #00A900;
  --color-ec-liveBg: #00A9001A;
  --color-ec-liveBorder: #00a9003D;
  --color-ec-trashText: #FF3A52;
  --color-ec-trashBg: #FF3A521A;
  --color-ec-trashBorder: #ff3a523D;
  --color-ec-draftText: #E8A700;
  --color-ec-draftBg: #E8A7001A;
  --color-ec-draftBorder: #e8a7003D;
  --color-ec-completedText: #00A900;
  --color-ec-completedBg: #00A9001A;
  --color-ec-completedBorder: #00a9003D;
  --color-ec-pendingText: #FFB310;
  --color-ec-pendingBg: #FFB3101A;
  --color-ec-pendingBorder: #ffb3103D;
  --color-ec-processingText: #1495FF;
  --color-ec-processingBg: #1495FF1A;
  --color-ec-processingBorder: #1495ff3D;
  --color-ec-refundedText: #FF001F;
  --color-ec-refundedBg: #FF001F1A;
  --color-ec-refundedBorder: #ff001f3D;
  --color-ec-cancelledText: #FF1F78;
  --color-ec-cancelledBg: #FF1F781A;
  --color-ec-cancelledBorder: #ff1f783D;
  --color-ec-onHoldText: #555DFF;
  --color-ec-onHoldBg: #555DFF1A;
  --color-ec-onHoldBorder: #555dff3D;
  --color-ec-fullfillText: #00A900;
  --color-ec-fullfillBg: #00A9001A;
  --color-ec-fullfillBorder: #00a9003D;
  --color-ec-partiallyFullfilledText: #FFB310;
  --color-ec-partiallyFullfilledBg: #FFB3101A;
  --color-ec-partiallyFullfilledBorder: #ffb3103D;
  --color-ec-shippedText: #1495FF;
  --color-ec-shippedBg: #1495FF1A;
  --color-ec-shippedBorder: #1495ff3D;
  --color-ec-returnedText: #FF001F;
  --color-ec-returnedBg: #FF001F1A;
  --color-ec-returnedBorder: #ff001f3D;
  --color-ec-unfullfilledText: #FF1F78;
  --color-ec-unfullfilledBg: #FF1F781A;
  --color-ec-unfullfilledBorder: #ff1f783D;
  --color-ec-deliveredText: #555DFF;
  --color-ec-deliveredBg: #555DFF1A;
  --color-ec-deliveredBorder: #555dff3D;
  --color-ec-notContractedText: #FF3A52;
  --color-ec-notContractedBg: #FF3A521A;
  --color-ec-notContractedBorder: #ff3a523D;
  --color-ec-contractedText: #7351FD;
  --color-ec-contractedBg: #7351FD1A;
  --color-ec-contractedBorder: #7351fd3D;
  --color-ec-recoveredText: #009D68;
  --color-ec-recoveredBg: #009D681A;
  --color-ec-recoveredBorder: #009d683D;
  --color-ec-paymentText: #009D68;
  --color-ec-paymentBg: #009D681A;
  --color-ec-paymentBorder: #009d683D;
  --color-ec-refundText: #FF3A52;
  --color-ec-refundBg: #FF3A521A;
  --color-ec-refundBorder: #ff3a523D;
  --color-ec-adjustmentText: #7351FD;
  --color-ec-adjustmentBg: #7351FD1A;
  --color-ec-adjustmentBorder: #7351fd3D;
  --color-ec-oneTimeText: #009D68;
  --color-ec-oneTimeBg: #009D681A;
  --color-ec-oneTimeBorder: #009d683D;
  --color-ec-recurringText: #FF3A52;
  --color-ec-recurringBg: #FF3A521A;
  --color-ec-recurringBorder: #ff3a523D;
  --color-ec-activeText: #009D68;
  --color-ec-activeBg: #009D681A;
  --color-ec-activeBorder: #009d683D;
  --color-ec-inactiveText: #FF3A52;
  --color-ec-inactiveBg: #FF3A521A;
  --color-ec-inactiveBorder: #ff3a523D;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 874px) {

  .container {
    max-width: 874px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.pointer-events-none {
  pointer-events: none !important;
}
.visible {
  visibility: visible !important;
}
.invisible {
  visibility: hidden !important;
}
.collapse {
  visibility: collapse !important;
}
.static {
  position: static !important;
}
.fixed {
  position: fixed !important;
}
.absolute {
  position: absolute !important;
}
.relative {
  position: relative !important;
}
.inset-0 {
  inset: 0px !important;
}
.-bottom-7 {
  bottom: -1.75rem !important;
}
.-bottom-\\[49px\\] {
  bottom: -49px !important;
}
.-right-1 {
  right: -0.25rem !important;
}
.-right-2 {
  right: -0.5rem !important;
}
.-right-\\[10px\\] {
  right: -10px !important;
}
.-top-2 {
  top: -0.5rem !important;
}
.-top-8 {
  top: -2rem !important;
}
.-top-\\[33px\\] {
  top: -33px !important;
}
.bottom-0 {
  bottom: 0px !important;
}
.bottom-6 {
  bottom: 1.5rem !important;
}
.bottom-\\[calc\\(100\\%\\+10px\\)\\] {
  bottom: calc(100% + 10px) !important;
}
.left-0 {
  left: 0px !important;
}
.left-1\\/2 {
  left: 50% !important;
}
.left-3 {
  left: 0.75rem !important;
}
.left-4 {
  left: 1rem !important;
}
.left-\\[-77px\\] {
  left: -77px !important;
}
.left-\\[15px\\] {
  left: 15px !important;
}
.left-\\[30px\\] {
  left: 30px !important;
}
.left-\\[445px\\] {
  left: 445px !important;
}
.left-\\[446px\\] {
  left: 446px !important;
}
.left-\\[50\\%\\] {
  left: 50% !important;
}
.left-\\[530px\\] {
  left: 530px !important;
}
.left-\\[90px\\] {
  left: 90px !important;
}
.right-0 {
  right: 0px !important;
}
.right-3 {
  right: 0.75rem !important;
}
.right-6 {
  right: 1.5rem !important;
}
.right-\\[-18px\\] {
  right: -18px !important;
}
.right-\\[-20px\\] {
  right: -20px !important;
}
.right-\\[-23px\\] {
  right: -23px !important;
}
.right-\\[-48px\\] {
  right: -48px !important;
}
.right-\\[-60px\\] {
  right: -60px !important;
}
.right-\\[51px\\] {
  right: 51px !important;
}
.right-\\[68px\\] {
  right: 68px !important;
}
.right-\\[7px\\] {
  right: 7px !important;
}
.right-\\[9px\\] {
  right: 9px !important;
}
.top-0 {
  top: 0px !important;
}
.top-1\\/2 {
  top: 50% !important;
}
.top-10 {
  top: 2.5rem !important;
}
.top-12 {
  top: 3rem !important;
}
.top-14 {
  top: 3.5rem !important;
}
.top-16 {
  top: 4rem !important;
}
.top-20 {
  top: 5rem !important;
}
.top-8 {
  top: 2rem !important;
}
.top-\\[-15px\\] {
  top: -15px !important;
}
.top-\\[-18px\\] {
  top: -18px !important;
}
.top-\\[-20px\\] {
  top: -20px !important;
}
.top-\\[10\\%\\] {
  top: 10% !important;
}
.top-\\[110\\%\\] {
  top: 110% !important;
}
.top-\\[48px\\] {
  top: 48px !important;
}
.top-\\[55px\\] {
  top: 55px !important;
}
.top-\\[68px\\] {
  top: 68px !important;
}
.top-\\[7px\\] {
  top: 7px !important;
}
.top-\\[90px\\] {
  top: 90px !important;
}
.top-\\[9px\\] {
  top: 9px !important;
}
.top-\\[calc\\(100\\%\\+10px\\)\\] {
  top: calc(100% + 10px) !important;
}
.top-full {
  top: 100% !important;
}
.z-0 {
  z-index: 0 !important;
}
.z-10 {
  z-index: 10 !important;
}
.z-20 {
  z-index: 20 !important;
}
.z-50 {
  z-index: 50 !important;
}
.z-\\[10000\\] {
  z-index: 10000 !important;
}
.z-\\[999999\\] {
  z-index: 999999 !important;
}
.z-\\[9999\\] {
  z-index: 9999 !important;
}
.z-\\[99\\] {
  z-index: 99 !important;
}
.col-span-1 {
  grid-column: span 1 / span 1 !important;
}
.col-span-10 {
  grid-column: span 10 / span 10 !important;
}
.col-span-12 {
  grid-column: span 12 / span 12 !important;
}
.col-span-2 {
  grid-column: span 2 / span 2 !important;
}
.col-span-3 {
  grid-column: span 3 / span 3 !important;
}
.col-span-4 {
  grid-column: span 4 / span 4 !important;
}
.col-span-5 {
  grid-column: span 5 / span 5 !important;
}
.col-span-6 {
  grid-column: span 6 / span 6 !important;
}
.col-span-7 {
  grid-column: span 7 / span 7 !important;
}
.col-span-8 {
  grid-column: span 8 / span 8 !important;
}
.float-right {
  float: right !important;
}
.\\!m-0 {
  margin: 0px !important;
}
.m-0 {
  margin: 0px !important;
}
.m-5 {
  margin: 1.25rem !important;
}
.m-\\[15px\\] {
  margin: 15px !important;
}
.m-\\[30px\\] {
  margin: 30px !important;
}
.\\!my-20 {
  margin-top: 5rem !important;
  margin-bottom: 5rem !important;
}
.mx-1 {
  margin-left: 0.25rem !important;
  margin-right: 0.25rem !important;
}
.mx-2 {
  margin-left: 0.5rem !important;
  margin-right: 0.5rem !important;
}
.mx-\\[2px\\] {
  margin-left: 2px !important;
  margin-right: 2px !important;
}
.mx-\\[30px\\] {
  margin-left: 30px !important;
  margin-right: 30px !important;
}
.mx-auto {
  margin-left: auto !important;
  margin-right: auto !important;
}
.my-10 {
  margin-top: 2.5rem !important;
  margin-bottom: 2.5rem !important;
}
.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}
.my-3 {
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
}
.my-4 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}
.my-6 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}
.my-\\[16px\\] {
  margin-top: 16px !important;
  margin-bottom: 16px !important;
}
.\\!mb-0 {
  margin-bottom: 0px !important;
}
.\\!mb-1 {
  margin-bottom: 0.25rem !important;
}
.\\!mb-2 {
  margin-bottom: 0.5rem !important;
}
.-mb-\\[1px\\] {
  margin-bottom: -1px !important;
}
.mb-0 {
  margin-bottom: 0px !important;
}
.mb-1 {
  margin-bottom: 0.25rem !important;
}
.mb-10 {
  margin-bottom: 2.5rem !important;
}
.mb-12 {
  margin-bottom: 3rem !important;
}
.mb-2 {
  margin-bottom: 0.5rem !important;
}
.mb-2\\.5 {
  margin-bottom: 0.625rem !important;
}
.mb-3 {
  margin-bottom: 0.75rem !important;
}
.mb-4 {
  margin-bottom: 1rem !important;
}
.mb-5 {
  margin-bottom: 1.25rem !important;
}
.mb-6 {
  margin-bottom: 1.5rem !important;
}
.mb-8 {
  margin-bottom: 2rem !important;
}
.mb-\\[10px\\] {
  margin-bottom: 10px !important;
}
.mb-\\[13px\\] {
  margin-bottom: 13px !important;
}
.mb-\\[14px\\] {
  margin-bottom: 14px !important;
}
.mb-\\[16px\\] {
  margin-bottom: 16px !important;
}
.mb-\\[24px\\] {
  margin-bottom: 24px !important;
}
.mb-\\[2px\\] {
  margin-bottom: 2px !important;
}
.mb-\\[30px\\] {
  margin-bottom: 30px !important;
}
.mb-\\[35px\\] {
  margin-bottom: 35px !important;
}
.mb-\\[50px\\] {
  margin-bottom: 50px !important;
}
.mb-\\[5px\\] {
  margin-bottom: 5px !important;
}
.mb-\\[6px\\] {
  margin-bottom: 6px !important;
}
.ml-0 {
  margin-left: 0px !important;
}
.ml-1 {
  margin-left: 0.25rem !important;
}
.ml-10 {
  margin-left: 2.5rem !important;
}
.ml-2 {
  margin-left: 0.5rem !important;
}
.ml-3 {
  margin-left: 0.75rem !important;
}
.ml-4 {
  margin-left: 1rem !important;
}
.ml-6 {
  margin-left: 1.5rem !important;
}
.ml-\\[10px\\] {
  margin-left: 10px !important;
}
.ml-\\[16px\\] {
  margin-left: 16px !important;
}
.ml-\\[30px\\] {
  margin-left: 30px !important;
}
.ml-\\[70px\\] {
  margin-left: 70px !important;
}
.ml-auto {
  margin-left: auto !important;
}
.mr-1 {
  margin-right: 0.25rem !important;
}
.mr-12 {
  margin-right: 3rem !important;
}
.mr-2 {
  margin-right: 0.5rem !important;
}
.mr-3 {
  margin-right: 0.75rem !important;
}
.mr-4 {
  margin-right: 1rem !important;
}
.mr-5 {
  margin-right: 1.25rem !important;
}
.mr-6 {
  margin-right: 1.5rem !important;
}
.mr-8 {
  margin-right: 2rem !important;
}
.mr-\\[10px\\] {
  margin-right: 10px !important;
}
.mr-\\[30px\\] {
  margin-right: 30px !important;
}
.mr-\\[5px\\] {
  margin-right: 5px !important;
}
.mt-1 {
  margin-top: 0.25rem !important;
}
.mt-10 {
  margin-top: 2.5rem !important;
}
.mt-11 {
  margin-top: 2.75rem !important;
}
.mt-12 {
  margin-top: 3rem !important;
}
.mt-14 {
  margin-top: 3.5rem !important;
}
.mt-2 {
  margin-top: 0.5rem !important;
}
.mt-20 {
  margin-top: 5rem !important;
}
.mt-3 {
  margin-top: 0.75rem !important;
}
.mt-4 {
  margin-top: 1rem !important;
}
.mt-5 {
  margin-top: 1.25rem !important;
}
.mt-6 {
  margin-top: 1.5rem !important;
}
.mt-8 {
  margin-top: 2rem !important;
}
.mt-9 {
  margin-top: 2.25rem !important;
}
.mt-\\[-15px\\] {
  margin-top: -15px !important;
}
.mt-\\[10px\\] {
  margin-top: 10px !important;
}
.mt-\\[15px\\] {
  margin-top: 15px !important;
}
.mt-\\[2px\\] {
  margin-top: 2px !important;
}
.mt-\\[30px\\] {
  margin-top: 30px !important;
}
.mt-\\[35px\\] {
  margin-top: 35px !important;
}
.mt-\\[50px\\] {
  margin-top: 50px !important;
}
.mt-\\[52px\\] {
  margin-top: 52px !important;
}
.mt-\\[70px\\] {
  margin-top: 70px !important;
}
.line-clamp-2 {
  overflow: hidden !important;
  display: -webkit-box !important;
  -webkit-box-orient: vertical !important;
  -webkit-line-clamp: 2 !important;
}
.block {
  display: block !important;
}
.inline-block {
  display: inline-block !important;
}
.flex {
  display: flex !important;
}
.inline-flex {
  display: inline-flex !important;
}
.table {
  display: table !important;
}
.grid {
  display: grid !important;
}
.contents {
  display: contents !important;
}
.\\!hidden {
  display: none !important;
}
.hidden {
  display: none !important;
}
.size-4 {
  width: 1rem !important;
  height: 1rem !important;
}
.size-5 {
  width: 1.25rem !important;
  height: 1.25rem !important;
}
.size-6 {
  width: 1.5rem !important;
  height: 1.5rem !important;
}
.h-10 {
  height: 2.5rem !important;
}
.h-11 {
  height: 2.75rem !important;
}
.h-12 {
  height: 3rem !important;
}
.h-14 {
  height: 3.5rem !important;
}
.h-2 {
  height: 0.5rem !important;
}
.h-24 {
  height: 6rem !important;
}
.h-3 {
  height: 0.75rem !important;
}
.h-4 {
  height: 1rem !important;
}
.h-40 {
  height: 10rem !important;
}
.h-48 {
  height: 12rem !important;
}
.h-5 {
  height: 1.25rem !important;
}
.h-6 {
  height: 1.5rem !important;
}
.h-7 {
  height: 1.75rem !important;
}
.h-8 {
  height: 2rem !important;
}
.h-9 {
  height: 2.25rem !important;
}
.h-\\[100px\\] {
  height: 100px !important;
}
.h-\\[102px\\] {
  height: 102px !important;
}
.h-\\[108px\\] {
  height: 108px !important;
}
.h-\\[10px\\] {
  height: 10px !important;
}
.h-\\[110px\\] {
  height: 110px !important;
}
.h-\\[112px\\] {
  height: 112px !important;
}
.h-\\[114px\\] {
  height: 114px !important;
}
.h-\\[115px\\] {
  height: 115px !important;
}
.h-\\[118px\\] {
  height: 118px !important;
}
.h-\\[120px\\] {
  height: 120px !important;
}
.h-\\[122px\\] {
  height: 122px !important;
}
.h-\\[12px\\] {
  height: 12px !important;
}
.h-\\[13px\\] {
  height: 13px !important;
}
.h-\\[14px\\] {
  height: 14px !important;
}
.h-\\[150px\\] {
  height: 150px !important;
}
.h-\\[16px\\] {
  height: 16px !important;
}
.h-\\[183px\\] {
  height: 183px !important;
}
.h-\\[18px\\] {
  height: 18px !important;
}
.h-\\[19px\\] {
  height: 19px !important;
}
.h-\\[207px\\] {
  height: 207px !important;
}
.h-\\[21px\\] {
  height: 21px !important;
}
.h-\\[240px\\] {
  height: 240px !important;
}
.h-\\[24px\\] {
  height: 24px !important;
}
.h-\\[26px\\] {
  height: 26px !important;
}
.h-\\[300px\\] {
  height: 300px !important;
}
.h-\\[30px\\] {
  height: 30px !important;
}
.h-\\[325px\\] {
  height: 325px !important;
}
.h-\\[32px\\] {
  height: 32px !important;
}
.h-\\[33px\\] {
  height: 33px !important;
}
.h-\\[350px\\] {
  height: 350px !important;
}
.h-\\[35px\\] {
  height: 35px !important;
}
.h-\\[36px\\] {
  height: 36px !important;
}
.h-\\[37px\\] {
  height: 37px !important;
}
.h-\\[38px\\] {
  height: 38px !important;
}
.h-\\[40px\\] {
  height: 40px !important;
}
.h-\\[412px\\] {
  height: 412px !important;
}
.h-\\[41px\\] {
  height: 41px !important;
}
.h-\\[42px\\] {
  height: 42px !important;
}
.h-\\[43px\\] {
  height: 43px !important;
}
.h-\\[44px\\] {
  height: 44px !important;
}
.h-\\[45px\\] {
  height: 45px !important;
}
.h-\\[47px\\] {
  height: 47px !important;
}
.h-\\[48px\\] {
  height: 48px !important;
}
.h-\\[50px\\] {
  height: 50px !important;
}
.h-\\[53px\\] {
  height: 53px !important;
}
.h-\\[55px\\] {
  height: 55px !important;
}
.h-\\[56px\\] {
  height: 56px !important;
}
.h-\\[57px\\] {
  height: 57px !important;
}
.h-\\[600px\\] {
  height: 600px !important;
}
.h-\\[60px\\] {
  height: 60px !important;
}
.h-\\[650px\\] {
  height: 650px !important;
}
.h-\\[654px\\] {
  height: 654px !important;
}
.h-\\[65px\\] {
  height: 65px !important;
}
.h-\\[70px\\] {
  height: 70px !important;
}
.h-\\[76px\\] {
  height: 76px !important;
}
.h-\\[7px\\] {
  height: 7px !important;
}
.h-\\[80px\\] {
  height: 80px !important;
}
.h-\\[85\\%\\] {
  height: 85% !important;
}
.h-\\[86px\\] {
  height: 86px !important;
}
.h-\\[90px\\] {
  height: 90px !important;
}
.h-\\[98px\\] {
  height: 98px !important;
}
.h-auto {
  height: auto !important;
}
.h-full {
  height: 100% !important;
}
.h-lvh {
  height: 100lvh !important;
}
.h-screen {
  height: 100vh !important;
}
.max-h-40 {
  max-height: 10rem !important;
}
.max-h-\\[137px\\] {
  max-height: 137px !important;
}
.max-h-\\[300px\\] {
  max-height: 300px !important;
}
.max-h-\\[65vh\\] {
  max-height: 65vh !important;
}
.min-h-0 {
  min-height: 0px !important;
}
.min-h-60 {
  min-height: 15rem !important;
}
.min-h-96 {
  min-height: 24rem !important;
}
.min-h-\\[100px\\] {
  min-height: 100px !important;
}
.min-h-\\[350px\\] {
  min-height: 350px !important;
}
.min-h-\\[460px\\] {
  min-height: 460px !important;
}
.min-h-\\[600px\\] {
  min-height: 600px !important;
}
.min-h-\\[70px\\] {
  min-height: 70px !important;
}
.min-h-\\[calc\\(100vh-220px\\)\\] {
  min-height: calc(100vh - 220px) !important;
}
.min-h-full {
  min-height: 100% !important;
}
.min-h-screen {
  min-height: 100vh !important;
}
.min-h-svh {
  min-height: 100svh !important;
}
.\\!w-\\[14px\\] {
  width: 14px !important;
}
.\\!w-full {
  width: 100% !important;
}
.w-1 {
  width: 0.25rem !important;
}
.w-1\\/2 {
  width: 50% !important;
}
.w-1\\/3 {
  width: 33.333333% !important;
}
.w-1\\/4 {
  width: 25% !important;
}
.w-1\\/5 {
  width: 20% !important;
}
.w-10 {
  width: 2.5rem !important;
}
.w-12 {
  width: 3rem !important;
}
.w-16 {
  width: 4rem !important;
}
.w-2 {
  width: 0.5rem !important;
}
.w-2\\/5 {
  width: 40% !important;
}
.w-20 {
  width: 5rem !important;
}
.w-3 {
  width: 0.75rem !important;
}
.w-32 {
  width: 8rem !important;
}
.w-4 {
  width: 1rem !important;
}
.w-5 {
  width: 1.25rem !important;
}
.w-6 {
  width: 1.5rem !important;
}
.w-7 {
  width: 1.75rem !important;
}
.w-8 {
  width: 2rem !important;
}
.w-9 {
  width: 2.25rem !important;
}
.w-9\\/12 {
  width: 75% !important;
}
.w-\\[10\\%\\] {
  width: 10% !important;
}
.w-\\[100px\\] {
  width: 100px !important;
}
.w-\\[10px\\] {
  width: 10px !important;
}
.w-\\[11\\%\\] {
  width: 11% !important;
}
.w-\\[110px\\] {
  width: 110px !important;
}
.w-\\[111px\\] {
  width: 111px !important;
}
.w-\\[116px\\] {
  width: 116px !important;
}
.w-\\[118px\\] {
  width: 118px !important;
}
.w-\\[12\\%\\] {
  width: 12% !important;
}
.w-\\[120px\\] {
  width: 120px !important;
}
.w-\\[123px\\] {
  width: 123px !important;
}
.w-\\[124px\\] {
  width: 124px !important;
}
.w-\\[125px\\] {
  width: 125px !important;
}
.w-\\[12px\\] {
  width: 12px !important;
}
.w-\\[130px\\] {
  width: 130px !important;
}
.w-\\[132px\\] {
  width: 132px !important;
}
.w-\\[135px\\] {
  width: 135px !important;
}
.w-\\[14\\%\\] {
  width: 14% !important;
}
.w-\\[140px\\] {
  width: 140px !important;
}
.w-\\[14px\\] {
  width: 14px !important;
}
.w-\\[15\\%\\] {
  width: 15% !important;
}
.w-\\[150px\\] {
  width: 150px !important;
}
.w-\\[153px\\] {
  width: 153px !important;
}
.w-\\[158px\\] {
  width: 158px !important;
}
.w-\\[15px\\] {
  width: 15px !important;
}
.w-\\[160px\\] {
  width: 160px !important;
}
.w-\\[162px\\] {
  width: 162px !important;
}
.w-\\[168px\\] {
  width: 168px !important;
}
.w-\\[16px\\] {
  width: 16px !important;
}
.w-\\[17px\\] {
  width: 17px !important;
}
.w-\\[18\\%\\] {
  width: 18% !important;
}
.w-\\[180px\\] {
  width: 180px !important;
}
.w-\\[181px\\] {
  width: 181px !important;
}
.w-\\[185px\\] {
  width: 185px !important;
}
.w-\\[18px\\] {
  width: 18px !important;
}
.w-\\[190px\\] {
  width: 190px !important;
}
.w-\\[19px\\] {
  width: 19px !important;
}
.w-\\[20\\%\\] {
  width: 20% !important;
}
.w-\\[200px\\] {
  width: 200px !important;
}
.w-\\[210px\\] {
  width: 210px !important;
}
.w-\\[22\\%\\] {
  width: 22% !important;
}
.w-\\[220px\\] {
  width: 220px !important;
}
.w-\\[224px\\] {
  width: 224px !important;
}
.w-\\[230px\\] {
  width: 230px !important;
}
.w-\\[23px\\] {
  width: 23px !important;
}
.w-\\[240px\\] {
  width: 240px !important;
}
.w-\\[24px\\] {
  width: 24px !important;
}
.w-\\[25\\%\\] {
  width: 25% !important;
}
.w-\\[252px\\] {
  width: 252px !important;
}
.w-\\[267px\\] {
  width: 267px !important;
}
.w-\\[26px\\] {
  width: 26px !important;
}
.w-\\[285px\\] {
  width: 285px !important;
}
.w-\\[286px\\] {
  width: 286px !important;
}
.w-\\[30\\%\\] {
  width: 30% !important;
}
.w-\\[300px\\] {
  width: 300px !important;
}
.w-\\[310px\\] {
  width: 310px !important;
}
.w-\\[316px\\] {
  width: 316px !important;
}
.w-\\[32px\\] {
  width: 32px !important;
}
.w-\\[33px\\] {
  width: 33px !important;
}
.w-\\[35\\%\\] {
  width: 35% !important;
}
.w-\\[350px\\] {
  width: 350px !important;
}
.w-\\[354px\\] {
  width: 354px !important;
}
.w-\\[35px\\] {
  width: 35px !important;
}
.w-\\[38px\\] {
  width: 38px !important;
}
.w-\\[40\\%\\] {
  width: 40% !important;
}
.w-\\[42px\\] {
  width: 42px !important;
}
.w-\\[430px\\] {
  width: 430px !important;
}
.w-\\[45\\%\\] {
  width: 45% !important;
}
.w-\\[451px\\] {
  width: 451px !important;
}
.w-\\[45px\\] {
  width: 45px !important;
}
.w-\\[480px\\] {
  width: 480px !important;
}
.w-\\[492px\\] {
  width: 492px !important;
}
.w-\\[50\\%\\] {
  width: 50% !important;
}
.w-\\[50px\\] {
  width: 50px !important;
}
.w-\\[530px\\] {
  width: 530px !important;
}
.w-\\[532px\\] {
  width: 532px !important;
}
.w-\\[537px\\] {
  width: 537px !important;
}
.w-\\[53px\\] {
  width: 53px !important;
}
.w-\\[548px\\] {
  width: 548px !important;
}
.w-\\[550px\\] {
  width: 550px !important;
}
.w-\\[60px\\] {
  width: 60px !important;
}
.w-\\[614px\\] {
  width: 614px !important;
}
.w-\\[61px\\] {
  width: 61px !important;
}
.w-\\[626px\\] {
  width: 626px !important;
}
.w-\\[63\\%\\] {
  width: 63% !important;
}
.w-\\[632px\\] {
  width: 632px !important;
}
.w-\\[65\\%\\] {
  width: 65% !important;
}
.w-\\[65px\\] {
  width: 65px !important;
}
.w-\\[660px\\] {
  width: 660px !important;
}
.w-\\[70\\%\\] {
  width: 70% !important;
}
.w-\\[70px\\] {
  width: 70px !important;
}
.w-\\[725px\\] {
  width: 725px !important;
}
.w-\\[73px\\] {
  width: 73px !important;
}
.w-\\[74\\%\\] {
  width: 74% !important;
}
.w-\\[75\\%\\] {
  width: 75% !important;
}
.w-\\[75px\\] {
  width: 75px !important;
}
.w-\\[80\\%\\] {
  width: 80% !important;
}
.w-\\[80px\\] {
  width: 80px !important;
}
.w-\\[86px\\] {
  width: 86px !important;
}
.w-\\[870px\\] {
  width: 870px !important;
}
.w-\\[88px\\] {
  width: 88px !important;
}
.w-\\[90\\%\\] {
  width: 90% !important;
}
.w-\\[92px\\] {
  width: 92px !important;
}
.w-\\[94px\\] {
  width: 94px !important;
}
.w-\\[95\\%\\] {
  width: 95% !important;
}
.w-\\[95px\\] {
  width: 95px !important;
}
.w-\\[970px\\] {
  width: 970px !important;
}
.w-\\[98px\\] {
  width: 98px !important;
}
.w-\\[9px\\] {
  width: 9px !important;
}
.w-\\[calc\\(100\\%_-_100px\\)\\] {
  width: calc(100% - 100px) !important;
}
.w-\\[calc\\(100\\%_-_30px\\)\\] {
  width: calc(100% - 30px) !important;
}
.w-\\[calc\\(100\\%_-_330px\\)\\] {
  width: calc(100% - 330px) !important;
}
.w-\\[calc\\(100\\%_-_354px\\)\\] {
  width: calc(100% - 354px) !important;
}
.w-\\[calc\\(100\\%_-_400px\\)\\] {
  width: calc(100% - 400px) !important;
}
.w-\\[calc\\(100\\%_-_50px\\)\\] {
  width: calc(100% - 50px) !important;
}
.w-\\[calc\\(100\\%_-_570px\\)\\] {
  width: calc(100% - 570px) !important;
}
.w-\\[calc\\(100\\%_-_60px\\)\\] {
  width: calc(100% - 60px) !important;
}
.w-\\[calc\\(100\\%_-_626px\\)\\] {
  width: calc(100% - 626px) !important;
}
.w-\\[calc\\(100\\%_-_62px\\)\\] {
  width: calc(100% - 62px) !important;
}
.w-auto {
  width: auto !important;
}
.w-full {
  width: 100% !important;
}
.w-max {
  width: -moz-max-content !important;
  width: max-content !important;
}
.w-screen {
  width: 100vw !important;
}
.min-w-48 {
  min-width: 12rem !important;
}
.min-w-5 {
  min-width: 1.25rem !important;
}
.min-w-\\[100px\\] {
  min-width: 100px !important;
}
.min-w-\\[1024px\\] {
  min-width: 1024px !important;
}
.min-w-\\[120px\\] {
  min-width: 120px !important;
}
.min-w-\\[160px\\] {
  min-width: 160px !important;
}
.min-w-\\[212px\\] {
  min-width: 212px !important;
}
.min-w-\\[320px\\] {
  min-width: 320px !important;
}
.min-w-\\[500px\\] {
  min-width: 500px !important;
}
.min-w-\\[54px\\] {
  min-width: 54px !important;
}
.\\!max-w-\\[620px\\] {
  max-width: 620px !important;
}
.max-w-\\[115px\\] {
  max-width: 115px !important;
}
.max-w-\\[217px\\] {
  max-width: 217px !important;
}
.max-w-\\[310px\\] {
  max-width: 310px !important;
}
.max-w-\\[344px\\] {
  max-width: 344px !important;
}
.max-w-full {
  max-width: 100% !important;
}
.max-w-max {
  max-width: -moz-max-content !important;
  max-width: max-content !important;
}
.flex-1 {
  flex: 1 1 0% !important;
}
.grow {
  flex-grow: 1 !important;
}
.grow-\\[1\\] {
  flex-grow: 1 !important;
}
.table-auto {
  table-layout: auto !important;
}
.border-collapse {
  border-collapse: collapse !important;
}
.border-separate {
  border-collapse: separate !important;
}
.border-spacing-0 {
  --tw-border-spacing-x: 0px !important;
  --tw-border-spacing-y: 0px !important;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y) !important;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-y-\\[calc\\(100\\%\\+10px\\)\\] {
  --tw-translate-y: calc(100% + 10px) !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.rotate-0 {
  --tw-rotate: 0deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.rotate-180 {
  --tw-rotate: 180deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.cursor-default {
  cursor: default !important;
}
.cursor-move {
  cursor: move !important;
}
.cursor-not-allowed {
  cursor: not-allowed !important;
}
.cursor-pointer {
  cursor: pointer !important;
}
.resize-none {
  resize: none !important;
}
.list-inside {
  list-style-position: inside !important;
}
.appearance-none {
  -webkit-appearance: none !important;
     -moz-appearance: none !important;
          appearance: none !important;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
}
.grid-cols-10 {
  grid-template-columns: repeat(10, minmax(0, 1fr)) !important;
}
.grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr)) !important;
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
}
.grid-cols-9 {
  grid-template-columns: repeat(9, minmax(0, 1fr)) !important;
}
.flex-row {
  flex-direction: row !important;
}
.flex-col {
  flex-direction: column !important;
}
.flex-wrap {
  flex-wrap: wrap !important;
}
.items-start {
  align-items: flex-start !important;
}
.items-end {
  align-items: flex-end !important;
}
.items-center {
  align-items: center !important;
}
.justify-start {
  justify-content: flex-start !important;
}
.justify-end {
  justify-content: flex-end !important;
}
.justify-center {
  justify-content: center !important;
}
.justify-between {
  justify-content: space-between !important;
}
.justify-evenly {
  justify-content: space-evenly !important;
}
.gap-0 {
  gap: 0px !important;
}
.gap-1 {
  gap: 0.25rem !important;
}
.gap-1\\.5 {
  gap: 0.375rem !important;
}
.gap-10 {
  gap: 2.5rem !important;
}
.gap-11 {
  gap: 2.75rem !important;
}
.gap-12 {
  gap: 3rem !important;
}
.gap-2 {
  gap: 0.5rem !important;
}
.gap-3 {
  gap: 0.75rem !important;
}
.gap-3\\.5 {
  gap: 0.875rem !important;
}
.gap-4 {
  gap: 1rem !important;
}
.gap-5 {
  gap: 1.25rem !important;
}
.gap-6 {
  gap: 1.5rem !important;
}
.gap-7 {
  gap: 1.75rem !important;
}
.gap-8 {
  gap: 2rem !important;
}
.gap-\\[10px\\] {
  gap: 10px !important;
}
.gap-\\[14px\\] {
  gap: 14px !important;
}
.gap-\\[17px\\] {
  gap: 17px !important;
}
.gap-\\[18px\\] {
  gap: 18px !important;
}
.gap-\\[24px\\] {
  gap: 24px !important;
}
.gap-\\[26px\\] {
  gap: 26px !important;
}
.gap-\\[2px\\] {
  gap: 2px !important;
}
.gap-\\[30px\\] {
  gap: 30px !important;
}
.gap-\\[3px\\] {
  gap: 3px !important;
}
.gap-\\[50px\\] {
  gap: 50px !important;
}
.gap-\\[52px\\] {
  gap: 52px !important;
}
.gap-\\[6px\\] {
  gap: 6px !important;
}
.gap-\\[7px\\] {
  gap: 7px !important;
}
.gap-\\[8px\\] {
  gap: 8px !important;
}
.space-x-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0 !important;
  margin-right: calc(0.125rem * var(--tw-space-x-reverse)) !important;
  margin-left: calc(0.125rem * calc(1 - var(--tw-space-x-reverse))) !important;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0 !important;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse)) !important;
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse))) !important;
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0 !important;
  margin-right: calc(1rem * var(--tw-space-x-reverse)) !important;
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse))) !important;
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse)) !important;
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(1rem * var(--tw-space-y-reverse)) !important;
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse)) !important;
}
.self-start {
  align-self: flex-start !important;
}
.overflow-hidden {
  overflow: hidden !important;
}
.overflow-scroll {
  overflow: scroll !important;
}
.overflow-x-auto {
  overflow-x: auto !important;
}
.overflow-y-auto {
  overflow-y: auto !important;
}
.overflow-x-scroll {
  overflow-x: scroll !important;
}
.overflow-y-scroll {
  overflow-y: scroll !important;
}
.whitespace-nowrap {
  white-space: nowrap !important;
}
.\\!rounded-lg {
  border-radius: 0.5rem !important;
}
.rounded {
  border-radius: 0.25rem !important;
}
.rounded-2xl {
  border-radius: 1rem !important;
}
.rounded-\\[10px\\] {
  border-radius: 10px !important;
}
.rounded-\\[12px\\] {
  border-radius: 12px !important;
}
.rounded-\\[20px\\] {
  border-radius: 20px !important;
}
.rounded-\\[22px\\] {
  border-radius: 22px !important;
}
.rounded-\\[3px\\] {
  border-radius: 3px !important;
}
.rounded-\\[4px\\] {
  border-radius: 4px !important;
}
.rounded-\\[5px\\] {
  border-radius: 5px !important;
}
.rounded-\\[6px\\] {
  border-radius: 6px !important;
}
.rounded-\\[8px\\] {
  border-radius: 8px !important;
}
.rounded-full {
  border-radius: 9999px !important;
}
.rounded-lg {
  border-radius: 0.5rem !important;
}
.rounded-md {
  border-radius: 0.375rem !important;
}
.rounded-none {
  border-radius: 0px !important;
}
.rounded-sm {
  border-radius: 0.125rem !important;
}
.rounded-xl {
  border-radius: 0.75rem !important;
}
.rounded-b-xl {
  border-bottom-right-radius: 0.75rem !important;
  border-bottom-left-radius: 0.75rem !important;
}
.rounded-e-lg {
  border-start-end-radius: 0.5rem !important;
  border-end-end-radius: 0.5rem !important;
}
.rounded-l-lg {
  border-top-left-radius: 0.5rem !important;
  border-bottom-left-radius: 0.5rem !important;
}
.rounded-l-md {
  border-top-left-radius: 0.375rem !important;
  border-bottom-left-radius: 0.375rem !important;
}
.rounded-r-lg {
  border-top-right-radius: 0.5rem !important;
  border-bottom-right-radius: 0.5rem !important;
}
.rounded-r-md {
  border-top-right-radius: 0.375rem !important;
  border-bottom-right-radius: 0.375rem !important;
}
.rounded-t-\\[22px\\] {
  border-top-left-radius: 22px !important;
  border-top-right-radius: 22px !important;
}
.rounded-t-lg {
  border-top-left-radius: 0.5rem !important;
  border-top-right-radius: 0.5rem !important;
}
.rounded-t-xl {
  border-top-left-radius: 0.75rem !important;
  border-top-right-radius: 0.75rem !important;
}
.rounded-bl-lg {
  border-bottom-left-radius: 0.5rem !important;
}
.rounded-bl-md {
  border-bottom-left-radius: 0.375rem !important;
}
.rounded-br-lg {
  border-bottom-right-radius: 0.5rem !important;
}
.rounded-br-md {
  border-bottom-right-radius: 0.375rem !important;
}
.rounded-tl-lg {
  border-top-left-radius: 0.5rem !important;
}
.rounded-tl-md {
  border-top-left-radius: 0.375rem !important;
}
.rounded-tr-lg {
  border-top-right-radius: 0.5rem !important;
}
.rounded-tr-md {
  border-top-right-radius: 0.375rem !important;
}
.border {
  border-width: 1px !important;
}
.border-0 {
  border-width: 0px !important;
}
.border-2 {
  border-width: 2px !important;
}
.border-\\[1px\\] {
  border-width: 1px !important;
}
.border-\\[2px\\] {
  border-width: 2px !important;
}
.border-b {
  border-bottom-width: 1px !important;
}
.border-b-0 {
  border-bottom-width: 0px !important;
}
.border-b-2 {
  border-bottom-width: 2px !important;
}
.border-b-\\[1px\\] {
  border-bottom-width: 1px !important;
}
.border-l {
  border-left-width: 1px !important;
}
.border-r {
  border-right-width: 1px !important;
}
.border-r-0 {
  border-right-width: 0px !important;
}
.border-r-4 {
  border-right-width: 4px !important;
}
.border-t {
  border-top-width: 1px !important;
}
.border-t-0 {
  border-top-width: 0px !important;
}
.border-t-2 {
  border-top-width: 2px !important;
}
.border-solid {
  border-style: solid !important;
}
.border-dashed {
  border-style: dashed !important;
}
.border-dotted {
  border-style: dotted !important;
}
.border-none {
  border-style: none !important;
}
.border-\\[\\#03836c\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(3 131 108 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#1203501A\\] {
  border-color: #1203501A !important;
}
.border-\\[\\#272435\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(39 36 53 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#7351FD08\\] {
  border-color: #7351FD08 !important;
}
.border-\\[\\#737991\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(115 121 145 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#DBDBDB\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(219 219 219 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#E0E8FF\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(224 232 255 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#E9E4FF\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(233 228 255 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#ECE6FF\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(236 230 255 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#EEEEEE\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(238 238 238 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#EEF4FF\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(238 244 255 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#F0EDFB\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(240 237 251 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#F7F7F8\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(247 247 248 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#F8F8F8\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(248 248 248 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#FAF9FF\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(250 249 255 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#e3e3e3\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(227 227 227 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#ffeeee\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 238 238 / var(--tw-border-opacity, 1)) !important;
}
.border-ec-body {
  --tw-border-opacity: 1 !important;
  border-color: rgb(60 60 66 / var(--tw-border-opacity, 1)) !important;
}
.border-ec-border {
  --tw-border-opacity: 1 !important;
  border-color: rgb(235 235 235 / var(--tw-border-opacity, 1)) !important;
}
.border-ec-cancelledBorder {
  border-color: #ff1f783D !important;
}
.border-ec-completedBorder {
  border-color: #00a9003D !important;
}
.border-ec-light-black {
  --tw-border-opacity: 1 !important;
  border-color: rgb(127 127 152 / var(--tw-border-opacity, 1)) !important;
}
.border-ec-onHoldBorder {
  border-color: #555dff3D !important;
}
.border-ec-pendingBorder {
  border-color: #ffb3103D !important;
}
.border-ec-primary {
  --tw-border-opacity: 1 !important;
  border-color: rgb(115 81 253 / var(--tw-border-opacity, 1)) !important;
}
.border-ec-processingBorder {
  border-color: #1495ff3D !important;
}
.border-ec-red {
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 58 82 / var(--tw-border-opacity, 1)) !important;
}
.border-ec-refundedBorder {
  border-color: #ff001f3D !important;
}
.border-ec-secondary {
  border-color: #7351FDCC !important;
}
.border-ec-table-stock {
  --tw-border-opacity: 1 !important;
  border-color: rgb(240 237 251 / var(--tw-border-opacity, 1)) !important;
}
.border-ec-title {
  --tw-border-opacity: 1 !important;
  border-color: rgb(18 18 22 / var(--tw-border-opacity, 1)) !important;
}
.border-transparent {
  border-color: transparent !important;
}
.border-b-ec-border {
  --tw-border-opacity: 1 !important;
  border-bottom-color: rgb(235 235 235 / var(--tw-border-opacity, 1)) !important;
}
.border-b-ec-placeholder {
  --tw-border-opacity: 1 !important;
  border-bottom-color: rgb(155 155 181 / var(--tw-border-opacity, 1)) !important;
}
.border-l-ec-border {
  --tw-border-opacity: 1 !important;
  border-left-color: rgb(235 235 235 / var(--tw-border-opacity, 1)) !important;
}
.border-r-\\[\\#0A875D\\] {
  --tw-border-opacity: 1 !important;
  border-right-color: rgb(10 135 93 / var(--tw-border-opacity, 1)) !important;
}
.border-r-\\[\\#19AA79\\] {
  --tw-border-opacity: 1 !important;
  border-right-color: rgb(25 170 121 / var(--tw-border-opacity, 1)) !important;
}
.border-r-\\[\\#2356D7\\] {
  --tw-border-opacity: 1 !important;
  border-right-color: rgb(35 86 215 / var(--tw-border-opacity, 1)) !important;
}
.border-r-\\[\\#5283FF\\] {
  --tw-border-opacity: 1 !important;
  border-right-color: rgb(82 131 255 / var(--tw-border-opacity, 1)) !important;
}
.border-r-\\[\\#5433DA\\] {
  --tw-border-opacity: 1 !important;
  border-right-color: rgb(84 51 218 / var(--tw-border-opacity, 1)) !important;
}
.border-r-\\[\\#7A59FF\\] {
  --tw-border-opacity: 1 !important;
  border-right-color: rgb(122 89 255 / var(--tw-border-opacity, 1)) !important;
}
.border-r-\\[\\#7AAA49\\] {
  --tw-border-opacity: 1 !important;
  border-right-color: rgb(122 170 73 / var(--tw-border-opacity, 1)) !important;
}
.border-r-\\[\\#88CD44\\] {
  --tw-border-opacity: 1 !important;
  border-right-color: rgb(136 205 68 / var(--tw-border-opacity, 1)) !important;
}
.border-r-\\[\\#9427E8\\] {
  --tw-border-opacity: 1 !important;
  border-right-color: rgb(148 39 232 / var(--tw-border-opacity, 1)) !important;
}
.border-r-\\[\\#B759FF\\] {
  --tw-border-opacity: 1 !important;
  border-right-color: rgb(183 89 255 / var(--tw-border-opacity, 1)) !important;
}
.border-r-\\[\\#D55D31\\] {
  --tw-border-opacity: 1 !important;
  border-right-color: rgb(213 93 49 / var(--tw-border-opacity, 1)) !important;
}
.border-r-\\[\\#E24476\\] {
  --tw-border-opacity: 1 !important;
  border-right-color: rgb(226 68 118 / var(--tw-border-opacity, 1)) !important;
}
.border-r-\\[\\#FD7F51\\] {
  --tw-border-opacity: 1 !important;
  border-right-color: rgb(253 127 81 / var(--tw-border-opacity, 1)) !important;
}
.border-r-\\[\\#FF598E\\] {
  --tw-border-opacity: 1 !important;
  border-right-color: rgb(255 89 142 / var(--tw-border-opacity, 1)) !important;
}
.border-r-ec-border {
  --tw-border-opacity: 1 !important;
  border-right-color: rgb(235 235 235 / var(--tw-border-opacity, 1)) !important;
}
.\\!bg-ec-primary {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(115 81 253 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#00000008\\] {
  background-color: #00000008 !important;
}
.bg-\\[\\#0000002B\\] {
  background-color: #0000002B !important;
}
.bg-\\[\\#0000003B\\] {
  background-color: #0000003B !important;
}
.bg-\\[\\#00000063\\] {
  background-color: #00000063 !important;
}
.bg-\\[\\#00000082\\] {
  background-color: #00000082 !important;
}
.bg-\\[\\#0000009f\\] {
  background-color: #0000009f !important;
}
.bg-\\[\\#00E91B\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 233 27 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#03836c\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(3 131 108 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#1212161A\\] {
  background-color: #1212161A !important;
}
.bg-\\[\\#1DE61D\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(29 230 29 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#272435\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(39 36 53 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#28A645\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(40 166 69 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#7351FD08\\] {
  background-color: #7351FD08 !important;
}
.bg-\\[\\#7351fd2a\\] {
  background-color: #7351fd2a !important;
}
.bg-\\[\\#B8D1BB\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(184 209 187 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#D9F0FF\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(217 240 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#DEF4F0\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(222 244 240 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#DFD7FE\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(223 215 254 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#E1F3E1\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(225 243 225 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#EEF0FF\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(238 240 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#EEF2FF\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#F0F2F4\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(240 242 244 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#F2F2F2\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(242 242 242 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#F4F0FF\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(244 240 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#F5F3FF\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#F8F8F8\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(248 248 248 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#F9F9F9\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(249 249 249 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#FF3A520D\\] {
  background-color: #FF3A520D !important;
}
.bg-\\[\\#FF3A521A\\] {
  background-color: #FF3A521A !important;
}
.bg-\\[\\#FFDBE0\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 219 224 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#FFDDF2\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 221 242 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#FFEFDA\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 239 218 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#FFF8F8\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 248 248 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#FFFFFF30\\] {
  background-color: #FFFFFF30 !important;
}
.bg-\\[\\#FFFFFF\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#cdcdcd\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(205 205 205 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#ffffff\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-ec-accent {
  background-color: #7351FD0D !important;
}
.bg-ec-activeBg {
  background-color: #009D681A !important;
}
.bg-ec-adjustmentBg {
  background-color: #7351FD1A !important;
}
.bg-ec-allBg {
  background-color: #1212161A !important;
}
.bg-ec-body {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(60 60 66 / var(--tw-bg-opacity, 1)) !important;
}
.bg-ec-cancelledBg {
  background-color: #FF1F781A !important;
}
.bg-ec-completedBg {
  background-color: #00A9001A !important;
}
.bg-ec-contractedBg {
  background-color: #7351FD1A !important;
}
.bg-ec-draftBg {
  background-color: #E8A7001A !important;
}
.bg-ec-inactiveBg {
  background-color: #FF3A521A !important;
}
.bg-ec-light-black {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(127 127 152 / var(--tw-bg-opacity, 1)) !important;
}
.bg-ec-liveBg {
  background-color: #00A9001A !important;
}
.bg-ec-main-bg {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(238 240 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-ec-modal {
  background-color: #00000008 !important;
}
.bg-ec-notContractedBg {
  background-color: #FF3A521A !important;
}
.bg-ec-onHoldBg {
  background-color: #555DFF1A !important;
}
.bg-ec-oneTimeBg {
  background-color: #009D681A !important;
}
.bg-ec-paymentBg {
  background-color: #009D681A !important;
}
.bg-ec-pendingBg {
  background-color: #FFB3101A !important;
}
.bg-ec-primary {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(115 81 253 / var(--tw-bg-opacity, 1)) !important;
}
.bg-ec-processingBg {
  background-color: #1495FF1A !important;
}
.bg-ec-recoveredBg {
  background-color: #009D681A !important;
}
.bg-ec-recurringBg {
  background-color: #FF3A521A !important;
}
.bg-ec-red {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 58 82 / var(--tw-bg-opacity, 1)) !important;
}
.bg-ec-refundBg {
  background-color: #FF3A521A !important;
}
.bg-ec-refundedBg {
  background-color: #FF001F1A !important;
}
.bg-ec-table-bg {
  background-color: #00000008 !important;
}
.bg-ec-table-stock {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(240 237 251 / var(--tw-bg-opacity, 1)) !important;
}
.bg-ec-trashBg {
  background-color: #FF3A521A !important;
}
.bg-gray-200 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1)) !important;
}
.bg-transparent {
  background-color: transparent !important;
}
.bg-white {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-cover {
  background-size: cover !important;
}
.bg-center {
  background-position: center !important;
}
.bg-no-repeat {
  background-repeat: no-repeat !important;
}
.fill-\\[\\#3C3C42\\] {
  fill: #3C3C42 !important;
}
.fill-\\[\\#7F7F98\\] {
  fill: #7F7F98 !important;
}
.fill-current {
  fill: currentColor !important;
}
.fill-ec-body {
  fill: #3C3C42 !important;
}
.fill-ec-light-black {
  fill: #7F7F98 !important;
}
.fill-ec-primary {
  fill: #7351FD !important;
}
.fill-gray-300 {
  fill: #d1d5db !important;
}
.fill-white {
  fill: #fff !important;
}
.object-contain {
  -o-object-fit: contain !important;
     object-fit: contain !important;
}
.object-cover {
  -o-object-fit: cover !important;
     object-fit: cover !important;
}
.object-fill {
  -o-object-fit: fill !important;
     object-fit: fill !important;
}
.p-0 {
  padding: 0px !important;
}
.p-1 {
  padding: 0.25rem !important;
}
.p-10 {
  padding: 2.5rem !important;
}
.p-2 {
  padding: 0.5rem !important;
}
.p-3 {
  padding: 0.75rem !important;
}
.p-4 {
  padding: 1rem !important;
}
.p-5 {
  padding: 1.25rem !important;
}
.p-6 {
  padding: 1.5rem !important;
}
.p-7 {
  padding: 1.75rem !important;
}
.p-8 {
  padding: 2rem !important;
}
.p-\\[10px\\] {
  padding: 10px !important;
}
.p-\\[11px\\] {
  padding: 11px !important;
}
.p-\\[13px\\] {
  padding: 13px !important;
}
.p-\\[15px\\] {
  padding: 15px !important;
}
.p-\\[18px\\] {
  padding: 18px !important;
}
.p-\\[26px\\] {
  padding: 26px !important;
}
.p-\\[30px\\] {
  padding: 30px !important;
}
.p-\\[3px\\] {
  padding: 3px !important;
}
.p-\\[5px\\] {
  padding: 5px !important;
}
.p-\\[6px\\] {
  padding: 6px !important;
}
.p-\\[7px\\] {
  padding: 7px !important;
}
.p-\\[9px\\] {
  padding: 9px !important;
}
.\\!py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.px-1 {
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
}
.px-10 {
  padding-left: 2.5rem !important;
  padding-right: 2.5rem !important;
}
.px-12 {
  padding-left: 3rem !important;
  padding-right: 3rem !important;
}
.px-16 {
  padding-left: 4rem !important;
  padding-right: 4rem !important;
}
.px-2 {
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.px-3 {
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.px-4 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.px-5 {
  padding-left: 1.25rem !important;
  padding-right: 1.25rem !important;
}
.px-6 {
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
}
.px-7 {
  padding-left: 1.75rem !important;
  padding-right: 1.75rem !important;
}
.px-8 {
  padding-left: 2rem !important;
  padding-right: 2rem !important;
}
.px-9 {
  padding-left: 2.25rem !important;
  padding-right: 2.25rem !important;
}
.px-\\[100px\\] {
  padding-left: 100px !important;
  padding-right: 100px !important;
}
.px-\\[10px\\] {
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.px-\\[15px\\] {
  padding-left: 15px !important;
  padding-right: 15px !important;
}
.px-\\[17px\\] {
  padding-left: 17px !important;
  padding-right: 17px !important;
}
.px-\\[18px\\] {
  padding-left: 18px !important;
  padding-right: 18px !important;
}
.px-\\[22px\\] {
  padding-left: 22px !important;
  padding-right: 22px !important;
}
.px-\\[24px\\] {
  padding-left: 24px !important;
  padding-right: 24px !important;
}
.px-\\[2px\\] {
  padding-left: 2px !important;
  padding-right: 2px !important;
}
.px-\\[30px\\] {
  padding-left: 30px !important;
  padding-right: 30px !important;
}
.px-\\[45px\\] {
  padding-left: 45px !important;
  padding-right: 45px !important;
}
.px-\\[46px\\] {
  padding-left: 46px !important;
  padding-right: 46px !important;
}
.px-\\[50px\\] {
  padding-left: 50px !important;
  padding-right: 50px !important;
}
.px-\\[5px\\] {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.px-\\[6px\\] {
  padding-left: 6px !important;
  padding-right: 6px !important;
}
.px-\\[70px\\] {
  padding-left: 70px !important;
  padding-right: 70px !important;
}
.px-\\[7px\\] {
  padding-left: 7px !important;
  padding-right: 7px !important;
}
.px-\\[9px\\] {
  padding-left: 9px !important;
  padding-right: 9px !important;
}
.py-0\\.5 {
  padding-top: 0.125rem !important;
  padding-bottom: 0.125rem !important;
}
.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
.py-10 {
  padding-top: 2.5rem !important;
  padding-bottom: 2.5rem !important;
}
.py-11 {
  padding-top: 2.75rem !important;
  padding-bottom: 2.75rem !important;
}
.py-16 {
  padding-top: 4rem !important;
  padding-bottom: 4rem !important;
}
.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.py-3 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}
.py-3\\.5 {
  padding-top: 0.875rem !important;
  padding-bottom: 0.875rem !important;
}
.py-4 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}
.py-5 {
  padding-top: 1.25rem !important;
  padding-bottom: 1.25rem !important;
}
.py-6 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}
.py-9 {
  padding-top: 2.25rem !important;
  padding-bottom: 2.25rem !important;
}
.py-\\[10px\\] {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
.py-\\[11px\\] {
  padding-top: 11px !important;
  padding-bottom: 11px !important;
}
.py-\\[120px\\] {
  padding-top: 120px !important;
  padding-bottom: 120px !important;
}
.py-\\[12px\\] {
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}
.py-\\[14px\\] {
  padding-top: 14px !important;
  padding-bottom: 14px !important;
}
.py-\\[15px\\] {
  padding-top: 15px !important;
  padding-bottom: 15px !important;
}
.py-\\[20px\\] {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}
.py-\\[32px\\] {
  padding-top: 32px !important;
  padding-bottom: 32px !important;
}
.py-\\[3px\\] {
  padding-top: 3px !important;
  padding-bottom: 3px !important;
}
.py-\\[50px\\] {
  padding-top: 50px !important;
  padding-bottom: 50px !important;
}
.py-\\[68px\\] {
  padding-top: 68px !important;
  padding-bottom: 68px !important;
}
.py-\\[6px\\] {
  padding-top: 6px !important;
  padding-bottom: 6px !important;
}
.py-\\[77px\\] {
  padding-top: 77px !important;
  padding-bottom: 77px !important;
}
.py-\\[7px\\] {
  padding-top: 7px !important;
  padding-bottom: 7px !important;
}
.py-\\[8px\\] {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
.py-\\[9px\\] {
  padding-top: 9px !important;
  padding-bottom: 9px !important;
}
.pb-0 {
  padding-bottom: 0px !important;
}
.pb-1 {
  padding-bottom: 0.25rem !important;
}
.pb-10 {
  padding-bottom: 2.5rem !important;
}
.pb-14 {
  padding-bottom: 3.5rem !important;
}
.pb-16 {
  padding-bottom: 4rem !important;
}
.pb-2 {
  padding-bottom: 0.5rem !important;
}
.pb-3 {
  padding-bottom: 0.75rem !important;
}
.pb-4 {
  padding-bottom: 1rem !important;
}
.pb-5 {
  padding-bottom: 1.25rem !important;
}
.pb-6 {
  padding-bottom: 1.5rem !important;
}
.pb-8 {
  padding-bottom: 2rem !important;
}
.pb-\\[10px\\] {
  padding-bottom: 10px !important;
}
.pb-\\[120px\\] {
  padding-bottom: 120px !important;
}
.pb-\\[14px\\] {
  padding-bottom: 14px !important;
}
.pb-\\[15px\\] {
  padding-bottom: 15px !important;
}
.pb-\\[16px\\] {
  padding-bottom: 16px !important;
}
.pb-\\[30px\\] {
  padding-bottom: 30px !important;
}
.pb-\\[3px\\] {
  padding-bottom: 3px !important;
}
.pb-\\[40px\\] {
  padding-bottom: 40px !important;
}
.pb-\\[55px\\] {
  padding-bottom: 55px !important;
}
.pb-\\[5px\\] {
  padding-bottom: 5px !important;
}
.pb-\\[60px\\] {
  padding-bottom: 60px !important;
}
.pb-\\[65px\\] {
  padding-bottom: 65px !important;
}
.pl-0 {
  padding-left: 0px !important;
}
.pl-10 {
  padding-left: 2.5rem !important;
}
.pl-11 {
  padding-left: 2.75rem !important;
}
.pl-12 {
  padding-left: 3rem !important;
}
.pl-2 {
  padding-left: 0.5rem !important;
}
.pl-3 {
  padding-left: 0.75rem !important;
}
.pl-4 {
  padding-left: 1rem !important;
}
.pl-5 {
  padding-left: 1.25rem !important;
}
.pl-6 {
  padding-left: 1.5rem !important;
}
.pl-8 {
  padding-left: 2rem !important;
}
.pl-\\[14px\\] {
  padding-left: 14px !important;
}
.pl-\\[27px\\] {
  padding-left: 27px !important;
}
.pl-\\[7px\\] {
  padding-left: 7px !important;
}
.pr-10 {
  padding-right: 2.5rem !important;
}
.pr-2 {
  padding-right: 0.5rem !important;
}
.pr-3 {
  padding-right: 0.75rem !important;
}
.pr-4 {
  padding-right: 1rem !important;
}
.pr-5 {
  padding-right: 1.25rem !important;
}
.pr-6 {
  padding-right: 1.5rem !important;
}
.pr-8 {
  padding-right: 2rem !important;
}
.pt-0 {
  padding-top: 0px !important;
}
.pt-10 {
  padding-top: 2.5rem !important;
}
.pt-11 {
  padding-top: 2.75rem !important;
}
.pt-2 {
  padding-top: 0.5rem !important;
}
.pt-3 {
  padding-top: 0.75rem !important;
}
.pt-4 {
  padding-top: 1rem !important;
}
.pt-5 {
  padding-top: 1.25rem !important;
}
.pt-6 {
  padding-top: 1.5rem !important;
}
.pt-7 {
  padding-top: 1.75rem !important;
}
.pt-8 {
  padding-top: 2rem !important;
}
.pt-\\[10px\\] {
  padding-top: 10px !important;
}
.pt-\\[130px\\] {
  padding-top: 130px !important;
}
.pt-\\[140px\\] {
  padding-top: 140px !important;
}
.pt-\\[17px\\] {
  padding-top: 17px !important;
}
.pt-\\[20px\\] {
  padding-top: 20px !important;
}
.pt-\\[2px\\] {
  padding-top: 2px !important;
}
.pt-\\[30px\\] {
  padding-top: 30px !important;
}
.pt-\\[45px\\] {
  padding-top: 45px !important;
}
.pt-\\[50px\\] {
  padding-top: 50px !important;
}
.pt-\\[60px\\] {
  padding-top: 60px !important;
}
.pt-\\[70px\\] {
  padding-top: 70px !important;
}
.text-left {
  text-align: left !important;
}
.text-center {
  text-align: center !important;
}
.text-right {
  text-align: right !important;
}
.text-start {
  text-align: start !important;
}
.\\!font-inter {
  font-family: "Inter", sans-serif !important;
}
.font-inter {
  font-family: "Inter", sans-serif !important;
}
.\\!text-2xl {
  font-size: 1.5rem !important;
  line-height: 2rem !important;
}
.\\!text-\\[12px\\] {
  font-size: 12px !important;
}
.\\!text-base {
  font-size: 1rem !important;
  line-height: 1.5rem !important;
}
.\\!text-lg {
  font-size: 1.125rem !important;
  line-height: 1.75rem !important;
}
.text-2xl {
  font-size: 1.5rem !important;
  line-height: 2rem !important;
}
.text-\\[12px\\] {
  font-size: 12px !important;
}
.text-\\[14px\\] {
  font-size: 14px !important;
}
.text-\\[16px\\] {
  font-size: 16px !important;
}
.text-\\[26px\\] {
  font-size: 26px !important;
}
.text-\\[30px\\] {
  font-size: 30px !important;
}
.text-\\[32px\\] {
  font-size: 32px !important;
}
.text-\\[38px\\] {
  font-size: 38px !important;
}
.text-\\[40px\\] {
  font-size: 40px !important;
}
.text-base {
  font-size: 1rem !important;
  line-height: 1.5rem !important;
}
.text-lg {
  font-size: 1.125rem !important;
  line-height: 1.75rem !important;
}
.text-sm {
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}
.text-xl {
  font-size: 1.25rem !important;
  line-height: 1.75rem !important;
}
.text-xs {
  font-size: 0.75rem !important;
  line-height: 1rem !important;
}
.\\!font-semibold {
  font-weight: 600 !important;
}
.font-bold {
  font-weight: 700 !important;
}
.font-medium {
  font-weight: 500 !important;
}
.font-normal {
  font-weight: 400 !important;
}
.font-semibold {
  font-weight: 600 !important;
}
.uppercase {
  text-transform: uppercase !important;
}
.capitalize {
  text-transform: capitalize !important;
}
.italic {
  font-style: italic !important;
}
.\\!leading-8 {
  line-height: 2rem !important;
}
.\\!leading-\\[26px\\] {
  line-height: 26px !important;
}
.leading-10 {
  line-height: 2.5rem !important;
}
.leading-4 {
  line-height: 1rem !important;
}
.leading-5 {
  line-height: 1.25rem !important;
}
.leading-6 {
  line-height: 1.5rem !important;
}
.leading-7 {
  line-height: 1.75rem !important;
}
.leading-8 {
  line-height: 2rem !important;
}
.leading-\\[12px\\] {
  line-height: 12px !important;
}
.leading-\\[20px\\] {
  line-height: 20px !important;
}
.leading-\\[22px\\] {
  line-height: 22px !important;
}
.leading-\\[24px\\] {
  line-height: 24px !important;
}
.leading-\\[26px\\] {
  line-height: 26px !important;
}
.leading-\\[30px\\] {
  line-height: 30px !important;
}
.leading-\\[32px\\] {
  line-height: 32px !important;
}
.leading-\\[34px\\] {
  line-height: 34px !important;
}
.leading-\\[42px\\] {
  line-height: 42px !important;
}
.leading-\\[48px\\] {
  line-height: 48px !important;
}
.\\!text-black {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-ec-body {
  --tw-text-opacity: 1 !important;
  color: rgb(60 60 66 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-ec-placeholder {
  --tw-text-opacity: 1 !important;
  color: rgb(155 155 181 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#000000\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#00BF7F\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(0 191 127 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#120350\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(18 3 80 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#121216\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(18 18 22 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#175AEA\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(23 90 234 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#1A0180\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(26 1 128 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#272435\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(39 36 53 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#3C3C42\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(60 60 66 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#4a5568\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(74 85 104 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#5a5a5a\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(90 90 90 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#7351FD\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(115 81 253 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#737373\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(115 115 115 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#737791\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(115 119 145 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#DBDBDB\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(219 219 219 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#FF3A52\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(255 58 82 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#FF7373\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(255 115 115 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#FFBB00\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(255 187 0 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#bdbdbd\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(189 189 189 / var(--tw-text-opacity, 1)) !important;
}
.text-black {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}
.text-blue-500 {
  --tw-text-opacity: 1 !important;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1)) !important;
}
.text-blue-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1)) !important;
}
.text-current {
  color: currentColor !important;
}
.text-ec-activeText {
  --tw-text-opacity: 1 !important;
  color: rgb(0 157 104 / var(--tw-text-opacity, 1)) !important;
}
.text-ec-adjustmentText {
  --tw-text-opacity: 1 !important;
  color: rgb(115 81 253 / var(--tw-text-opacity, 1)) !important;
}
.text-ec-allText {
  --tw-text-opacity: 1 !important;
  color: rgb(18 18 22 / var(--tw-text-opacity, 1)) !important;
}
.text-ec-body {
  --tw-text-opacity: 1 !important;
  color: rgb(60 60 66 / var(--tw-text-opacity, 1)) !important;
}
.text-ec-cancelledText {
  --tw-text-opacity: 1 !important;
  color: rgb(255 31 120 / var(--tw-text-opacity, 1)) !important;
}
.text-ec-completedText {
  --tw-text-opacity: 1 !important;
  color: rgb(0 169 0 / var(--tw-text-opacity, 1)) !important;
}
.text-ec-contractedText {
  --tw-text-opacity: 1 !important;
  color: rgb(115 81 253 / var(--tw-text-opacity, 1)) !important;
}
.text-ec-draftText {
  --tw-text-opacity: 1 !important;
  color: rgb(232 167 0 / var(--tw-text-opacity, 1)) !important;
}
.text-ec-inactiveText {
  --tw-text-opacity: 1 !important;
  color: rgb(255 58 82 / var(--tw-text-opacity, 1)) !important;
}
.text-ec-light-black {
  --tw-text-opacity: 1 !important;
  color: rgb(127 127 152 / var(--tw-text-opacity, 1)) !important;
}
.text-ec-liveText {
  --tw-text-opacity: 1 !important;
  color: rgb(0 169 0 / var(--tw-text-opacity, 1)) !important;
}
.text-ec-notContractedText {
  --tw-text-opacity: 1 !important;
  color: rgb(255 58 82 / var(--tw-text-opacity, 1)) !important;
}
.text-ec-onHoldText {
  --tw-text-opacity: 1 !important;
  color: rgb(85 93 255 / var(--tw-text-opacity, 1)) !important;
}
.text-ec-oneTimeText {
  --tw-text-opacity: 1 !important;
  color: rgb(0 157 104 / var(--tw-text-opacity, 1)) !important;
}
.text-ec-paymentText {
  --tw-text-opacity: 1 !important;
  color: rgb(0 157 104 / var(--tw-text-opacity, 1)) !important;
}
.text-ec-pendingText {
  --tw-text-opacity: 1 !important;
  color: rgb(255 179 16 / var(--tw-text-opacity, 1)) !important;
}
.text-ec-placeholder {
  --tw-text-opacity: 1 !important;
  color: rgb(155 155 181 / var(--tw-text-opacity, 1)) !important;
}
.text-ec-primary {
  --tw-text-opacity: 1 !important;
  color: rgb(115 81 253 / var(--tw-text-opacity, 1)) !important;
}
.text-ec-processingText {
  --tw-text-opacity: 1 !important;
  color: rgb(20 149 255 / var(--tw-text-opacity, 1)) !important;
}
.text-ec-recoveredText {
  --tw-text-opacity: 1 !important;
  color: rgb(0 157 104 / var(--tw-text-opacity, 1)) !important;
}
.text-ec-recurringText {
  --tw-text-opacity: 1 !important;
  color: rgb(255 58 82 / var(--tw-text-opacity, 1)) !important;
}
.text-ec-red {
  --tw-text-opacity: 1 !important;
  color: rgb(255 58 82 / var(--tw-text-opacity, 1)) !important;
}
.text-ec-refundText {
  --tw-text-opacity: 1 !important;
  color: rgb(255 58 82 / var(--tw-text-opacity, 1)) !important;
}
.text-ec-refundedText {
  --tw-text-opacity: 1 !important;
  color: rgb(255 0 31 / var(--tw-text-opacity, 1)) !important;
}
.text-ec-secondary {
  color: #7351FDCC !important;
}
.text-ec-title {
  --tw-text-opacity: 1 !important;
  color: rgb(18 18 22 / var(--tw-text-opacity, 1)) !important;
}
.text-ec-trashText {
  --tw-text-opacity: 1 !important;
  color: rgb(255 58 82 / var(--tw-text-opacity, 1)) !important;
}
.text-gray-400 {
  --tw-text-opacity: 1 !important;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1)) !important;
}
.text-gray-500 {
  --tw-text-opacity: 1 !important;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1)) !important;
}
.text-gray-700 {
  --tw-text-opacity: 1 !important;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1)) !important;
}
.text-red-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1)) !important;
}
.text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.text-yellow-500 {
  --tw-text-opacity: 1 !important;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1)) !important;
}
.underline {
  text-decoration-line: underline !important;
}
.line-through {
  text-decoration-line: line-through !important;
}
.\\!no-underline {
  text-decoration-line: none !important;
}
.decoration-solid {
  text-decoration-style: solid !important;
}
.antialiased {
  -webkit-font-smoothing: antialiased !important;
  -moz-osx-font-smoothing: grayscale !important;
}
.placeholder-ec-light-black::-moz-placeholder {
  --tw-placeholder-opacity: 1 !important;
  color: rgb(127 127 152 / var(--tw-placeholder-opacity, 1)) !important;
}
.placeholder-ec-light-black::placeholder {
  --tw-placeholder-opacity: 1 !important;
  color: rgb(127 127 152 / var(--tw-placeholder-opacity, 1)) !important;
}
.placeholder-ec-placeholder::-moz-placeholder {
  --tw-placeholder-opacity: 1 !important;
  color: rgb(155 155 181 / var(--tw-placeholder-opacity, 1)) !important;
}
.placeholder-ec-placeholder::placeholder {
  --tw-placeholder-opacity: 1 !important;
  color: rgb(155 155 181 / var(--tw-placeholder-opacity, 1)) !important;
}
.accent-ec-primary {
  accent-color: #7351FD !important;
}
.opacity-0 {
  opacity: 0 !important;
}
.opacity-100 {
  opacity: 1 !important;
}
.opacity-50 {
  opacity: 0.5 !important;
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25) !important;
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-none {
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-search-box-shadow {
  --tw-shadow: 0px 9px 51.5px 0px #00000014 !important;
  --tw-shadow-colored: 0px 9px 51.5px 0px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-settings-shadow {
  --tw-shadow: 0px 30px 34px -2px #0000001F !important;
  --tw-shadow-colored: 0px 30px 34px -2px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05) !important;
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.outline-none {
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.outline {
  outline-style: solid !important;
}
.outline-0 {
  outline-width: 0px !important;
}
.blur {
  --tw-blur: blur(8px) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.backdrop-blur-\\[10px\\] {
  --tw-backdrop-blur: blur(10px) !important;
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px) !important;
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter !important;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter !important;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-all {
  transition-property: all !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-opacity {
  transition-property: opacity !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-shadow {
  transition-property: box-shadow !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-transform {
  transition-property: transform !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.duration-200 {
  transition-duration: 200ms !important;
}
.duration-300 {
  transition-duration: 300ms !important;
}
.duration-500 {
  transition-duration: 500ms !important;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
}
.\\[box-shadow\\:0_0_0_4px_\\#F3F0FF\\] {
  box-shadow: 0 0 0 4px #F3F0FF !important;
}

/* buttons */
.easycommerce-primary-button {
    position: relative;
    z-index: 1;
    width: -moz-max-content;
    width: max-content;
    overflow: hidden;
    border-radius: 8px;
    --tw-bg-opacity: 1;
    background-color: rgb(115 81 253 / var(--tw-bg-opacity, 1));
    padding-top: 11px;
    padding-bottom: 11px;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    line-height: 20px;
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
    transition-duration: 300ms;
}
.easycommerce-primary-button:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(102 64 255 / var(--tw-bg-opacity, 1));
}

.easycommerce-primary-button::before {
    content: "";
    position: absolute;
    inset: 0;
    padding: 2px;
    border-radius: 8px;
    background: linear-gradient(180deg, #8466FF 0%, #643DFF 100%);
    -webkit-mask: 
        linear-gradient(#fff 0 0) content-box, 
        linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    z-index: -1;
}

.easycommerce-outline-button {
  margin-top: 0.75rem;
  display: flex;
  height: 2.5rem;
  width: -moz-max-content;
  width: max-content;
  align-items: center;
  border-radius: 0.375rem;
  border-width: 1px;
  border-style: solid;
  --tw-border-opacity: 1;
  border-color: rgb(115 81 253 / var(--tw-border-opacity, 1));
  background-color: transparent;
  padding-left: 1rem;
  padding-right: 1rem;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 20px;
  --tw-text-opacity: 1;
  color: rgb(115 81 253 / var(--tw-text-opacity, 1));
  transition-duration: 300ms;
}

.easycommerce-outline-button:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(115 81 253 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.easycommerce-underline-button {
  width: -moz-max-content;
  width: max-content;
  border-bottom-width: 1px;
  border-style: solid;
  --tw-border-opacity: 1;
  border-color: rgb(60 60 66 / var(--tw-border-opacity, 1));
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 20px;
  --tw-text-opacity: 1;
  color: rgb(60 60 66 / var(--tw-text-opacity, 1));
  transition-duration: 300ms;
}
.easycommerce-underline-button:hover {
  --tw-border-opacity: 1;
  border-color: rgb(115 81 253 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(115 81 253 / var(--tw-text-opacity, 1));
}
.easycommerce-underline-button:focus {
  --tw-text-opacity: 1;
  color: rgb(115 81 253 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.easycommerce-delete-button {
  display: flex;
  height: 1.5rem;
  width: 1.5rem;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border-width: 1px;
  border-style: solid;
  --tw-border-opacity: 1;
  border-color: rgb(240 237 251 / var(--tw-border-opacity, 1));
  background-color: #7351FD08;
  transition-duration: 300ms;
}
.easycommerce-delete-button:hover {
  --tw-border-opacity: 1;
  border-color: rgb(255 58 82 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 58 82 / var(--tw-bg-opacity, 1));
}

/* Panels */
.easycommerce-product-section {
  border-radius: 0.75rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.product-panel-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 14px;
  padding-bottom: 14px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
    border-bottom: 1px solid #F0EDFB;
}
.product-panel-title {
  display: flex;
  height: 41px;
  align-items: center;
  gap: 0.75rem;
}
.product-panel-title h3 {
  font-family: "Inter", sans-serif;
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 500;
  line-height: 38px;
  --tw-text-opacity: 1;
  color: rgb(18 18 22 / var(--tw-text-opacity, 1));
}
.product-panel-title button.panel-info {
  border-style: none;
  background-color: transparent;
}
.product-panel-body {
  padding: 1.5rem;
    transition: 0.3s;
}
.panel-actions {
  display: flex;
  gap: 0.5rem;
}
.panel-actions button {
  display: flex;
  height: 2rem;
  width: 2rem;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding: 0.5rem;
    border: 1px solid #F0EDFB;
}
 button.ai-generate {
    background: linear-gradient(180deg, #7351FD 0%, #A33BFF 100%);
    border: none;
}
 button.ai-generate:hover {
    background: linear-gradient(180deg, #A33BFF 0%, #7351FD 100%);
    transition: 0.3s;
}
.panel-actions button.panel-drag {
    cursor: move;
}
.panel-actions button.panel-collapse svg {
    transition: 0.3s;
}
.panel-actions button.panel-collapse.collapsed svg {
    transform: rotate(180deg);
    transition: 0.3s;
}
.easycommerce-product-section.collapsed .product-panel-body {
    padding-top: 0;
    padding-bottom: 0;
    transition: 0.3s;
}
.easycommerce-product-section.collapsed .product-panel-body * {
    display: none;
}
.easycommerce-product-section.collapsed .product-panel-heading {
    border: none;
}

/* Input fields */
.easycommerce-product-section :is(input, textarea) {
  border-radius: 0.5rem;
  padding: 1rem;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
    border: 1px solid #F0EDFB;
}
.easycommerce-product-section :is(input, textarea)::-moz-placeholder {
  --tw-text-opacity: 1;
  color: rgb(155 155 181 / var(--tw-text-opacity, 1));
}
.easycommerce-product-section :is(input, textarea)::placeholder {
  --tw-text-opacity: 1;
  color: rgb(155 155 181 / var(--tw-text-opacity, 1));
}
.easycommerce-product-section :is(input, textarea):hover {
  --tw-border-opacity: 1;
  border-color: rgb(115 81 253 / var(--tw-border-opacity, 1));
    transition: border-color 0.3s ease;
}
.easycommerce-product-section :is(input, textarea):focus {
  --tw-border-opacity: 1;
  border-color: rgb(115 81 253 / var(--tw-border-opacity, 1));
    transition: border-color 0.3s ease;
    box-shadow: 0 0 0 4px #F3F0FF;
}

.easycommerce-datepicker-container .react-datepicker {
  border-radius: 0.5rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(115 81 253 / var(--tw-border-opacity, 1));
  font-family: "Inter", sans-serif;
}

.easycommerce-datepicker-container .react-datepicker__header {
  --tw-bg-opacity: 1;
  background-color: rgb(115 81 253 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.easycommerce-datepicker-container h2.react-datepicker__current-month {
  margin-bottom: 0.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.easycommerce-datepicker-container .react-datepicker__navigation-icon::before {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
    border-width: 1px 1px 0 0;
}

.easycommerce-datepicker-container .react-datepicker__day-name {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.easycommerce-datepicker-container .react-datepicker__navigation {
    top: 4px;
}

.easycommerce-datepicker-container .react-datepicker__day {
  --tw-text-opacity: 1;
  color: rgb(60 60 66 / var(--tw-text-opacity, 1));
}

.easycommerce-datepicker-container .react-datepicker__day--outside-month {
  --tw-text-opacity: 1;
  color: rgb(187 187 187 / var(--tw-text-opacity, 1));
}

.easycommerce-datepicker-container .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {
    fill: #7351FD;
    color: #7351FD;
}

.easycommerce-datepicker-container :is(.react-datepicker__day--selected:not([aria-disabled=true]):hover, .react-datepicker__day--in-selecting-range:not([aria-disabled=true]):hover, .react-datepicker__day--in-range:not([aria-disabled=true]):hover, .react-datepicker__month-text--selected:not([aria-disabled=true]):hover, .react-datepicker__month-text--in-selecting-range:not([aria-disabled=true]):hover, .react-datepicker__month-text--in-range:not([aria-disabled=true]):hover, .react-datepicker__quarter-text--selected:not([aria-disabled=true]):hover, .react-datepicker__quarter-text--in-selecting-range:not([aria-disabled=true]):hover, .react-datepicker__quarter-text--in-range:not([aria-disabled=true]):hover, .react-datepicker__year-text--selected:not([aria-disabled=true]):hover, .react-datepicker__year-text--in-selecting-range:not([aria-disabled=true]):hover, .react-datepicker__year-text--in-range:not([aria-disabled=true]):hover, .react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range, .react-datepicker__month-text--selected, .react-datepicker__month-text--in-selecting-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--selected, .react-datepicker__quarter-text--in-selecting-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--selected, .react-datepicker__year-text--in-selecting-range, .react-datepicker__year-text--in-range) {
  --tw-bg-opacity: 1;
  background-color: rgb(240 237 251 / var(--tw-bg-opacity, 1));
}

.ec-product-status-dropdown button {
    color: #7351FD !important;
    border-color: #7351FD !important;
}

.easycommerce-datepicker-container .react-datepicker__day--keyboard-selected, .react-datepicker__month-text--keyboard-selected, .react-datepicker__quarter-text--keyboard-selected, .react-datepicker__year-text--keyboard-selected {
  --tw-bg-opacity: 1;
  background-color: rgb(240 237 251 / var(--tw-bg-opacity, 1));
}

.placeholder\\:text-base::-moz-placeholder {
  font-size: 1rem !important;
  line-height: 1.5rem !important;
}

.placeholder\\:text-base::placeholder {
  font-size: 1rem !important;
  line-height: 1.5rem !important;
}

.placeholder\\:text-sm::-moz-placeholder {
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}

.placeholder\\:text-sm::placeholder {
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}

.placeholder\\:leading-\\[26px\\]::-moz-placeholder {
  line-height: 26px !important;
}

.placeholder\\:leading-\\[26px\\]::placeholder {
  line-height: 26px !important;
}

.placeholder\\:text-ec-placeholder::-moz-placeholder {
  --tw-text-opacity: 1 !important;
  color: rgb(155 155 181 / var(--tw-text-opacity, 1)) !important;
}

.placeholder\\:text-ec-placeholder::placeholder {
  --tw-text-opacity: 1 !important;
  color: rgb(155 155 181 / var(--tw-text-opacity, 1)) !important;
}

.after\\:absolute::after {
  content: var(--tw-content) !important;
  position: absolute !important;
}

.after\\:bottom-\\[-2px\\]::after {
  content: var(--tw-content) !important;
  bottom: -2px !important;
}

.after\\:left-0::after {
  content: var(--tw-content) !important;
  left: 0px !important;
}

.after\\:right-0::after {
  content: var(--tw-content) !important;
  right: 0px !important;
}

.after\\:h-\\[2px\\]::after {
  content: var(--tw-content) !important;
  height: 2px !important;
}

.after\\:bg-ec-primary::after {
  content: var(--tw-content) !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(115 81 253 / var(--tw-bg-opacity, 1)) !important;
}

.first\\:rounded-l-lg:first-child {
  border-top-left-radius: 0.5rem !important;
  border-bottom-left-radius: 0.5rem !important;
}

.last\\:rounded-r-lg:last-child {
  border-top-right-radius: 0.5rem !important;
  border-bottom-right-radius: 0.5rem !important;
}

.last\\:border-b-0:last-child {
  border-bottom-width: 0px !important;
}

.checked\\:bg-ec-primary:checked {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(115 81 253 / var(--tw-bg-opacity, 1)) !important;
}

.read-only\\:bg-white:-moz-read-only {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}

.read-only\\:bg-white:read-only {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}

.read-only\\:text-ec-body:-moz-read-only {
  --tw-text-opacity: 1 !important;
  color: rgb(60 60 66 / var(--tw-text-opacity, 1)) !important;
}

.read-only\\:text-ec-body:read-only {
  --tw-text-opacity: 1 !important;
  color: rgb(60 60 66 / var(--tw-text-opacity, 1)) !important;
}

.focus-within\\:border-ec-primary:focus-within {
  --tw-border-opacity: 1 !important;
  border-color: rgb(115 81 253 / var(--tw-border-opacity, 1)) !important;
}

.focus-within\\:outline-none:focus-within {
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}

.focus-within\\:\\[box-shadow\\:0_0_0_4px_\\#F3F0FF\\]:focus-within {
  box-shadow: 0 0 0 4px #F3F0FF !important;
}

.hover\\:scale-110:hover {
  --tw-scale-x: 1.1 !important;
  --tw-scale-y: 1.1 !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.hover\\:cursor-pointer:hover {
  cursor: pointer !important;
}

.hover\\:rounded-\\[6px\\]:hover {
  border-radius: 6px !important;
}

.hover\\:rounded-\\[8px\\]:hover {
  border-radius: 8px !important;
}

.hover\\:rounded-lg:hover {
  border-radius: 0.5rem !important;
}

.hover\\:border-none:hover {
  border-style: none !important;
}

.hover\\:\\!border-ec-secondary:hover {
  border-color: #7351FDCC !important;
}

.hover\\:border-\\[\\#1203501A\\]:hover {
  border-color: #1203501A !important;
}

.hover\\:border-\\[\\#FF3A521A\\]:hover {
  border-color: #FF3A521A !important;
}

.hover\\:border-\\[\\#FF3A52CC\\]:hover {
  border-color: #FF3A52CC !important;
}

.hover\\:border-\\[\\#FF3A52\\]:hover {
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 58 82 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:border-ec-border:hover {
  --tw-border-opacity: 1 !important;
  border-color: rgb(235 235 235 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:border-ec-primary:hover {
  --tw-border-opacity: 1 !important;
  border-color: rgb(115 81 253 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:border-ec-red:hover {
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 58 82 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:border-ec-secondary:hover {
  border-color: #7351FDCC !important;
}

.hover\\:\\!bg-ec-primary:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(115 81 253 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:\\!bg-ec-secondary:hover {
  background-color: #7351FDCC !important;
}

.hover\\:bg-\\[\\#026654\\]:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(2 102 84 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-\\[\\#6440f2\\]:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(100 64 242 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-\\[\\#7351FD08\\]:hover {
  background-color: #7351FD08 !important;
}

.hover\\:bg-\\[\\#F8F8F8\\]:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(248 248 248 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-\\[\\#FF3A520D\\]:hover {
  background-color: #FF3A520D !important;
}

.hover\\:bg-\\[\\#FF3A521A\\]:hover {
  background-color: #FF3A521A !important;
}

.hover\\:bg-\\[\\#FF3A52CC\\]:hover {
  background-color: #FF3A52CC !important;
}

.hover\\:bg-\\[\\#FF3A52\\]:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 58 82 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-\\[\\#e1e1fd\\]:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(225 225 253 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-\\[\\#fa4109\\]:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(250 65 9 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-\\[var\\(--color-ec-active\\)\\]:hover {
  background-color: var(--color-ec-active) !important;
}

.hover\\:bg-ec-accent:hover {
  background-color: #7351FD0D !important;
}

.hover\\:bg-ec-modal:hover {
  background-color: #00000008 !important;
}

.hover\\:bg-ec-primary:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(115 81 253 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-ec-red:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 58 82 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-ec-secondary:hover {
  background-color: #7351FDCC !important;
}

.hover\\:bg-ec-table-stock:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(240 237 251 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-gray-300:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-white:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:\\!text-ec-primary:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(115 81 253 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:\\!text-white:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-\\[\\#272435\\]:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(39 36 53 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-\\[\\#7351FD\\]:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(115 81 253 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-\\[\\#FF3A52\\]:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(255 58 82 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-blue-700:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-ec-body:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(60 60 66 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-ec-placeholder:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(155 155 181 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-ec-primary:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(115 81 253 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-ec-secondary:hover {
  color: #7351FDCC !important;
}

.hover\\:text-ec-title:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(18 18 22 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-gray-200:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-inherit:hover {
  color: inherit !important;
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:underline:hover {
  text-decoration-line: underline !important;
}

.hover\\:opacity-70:hover {
  opacity: 0.7 !important;
}

.hover\\:shadow-\\[0px_4px_20px_0px_\\#0000000F\\]:hover {
  --tw-shadow: 0px 4px 20px 0px #0000000F !important;
  --tw-shadow-colored: 0px 4px 20px 0px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.hover\\:shadow-\\[0px_4px_40px_0px_\\#00000014\\]:hover {
  --tw-shadow: 0px 4px 40px 0px #00000014 !important;
  --tw-shadow-colored: 0px 4px 40px 0px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.hover\\:shadow-\\[2px_22px_54\\.6px_0px_\\#EFEBFF\\]:hover {
  --tw-shadow: 2px 22px 54.6px 0px #EFEBFF !important;
  --tw-shadow-colored: 2px 22px 54.6px 0px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.hover\\:duration-500:hover {
  transition-duration: 500ms !important;
}

.hover\\:ease-in-out:hover {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.focus\\:border-0:focus {
  border-width: 0px !important;
}

.focus\\:\\!border-ec-primary:focus {
  --tw-border-opacity: 1 !important;
  border-color: rgb(115 81 253 / var(--tw-border-opacity, 1)) !important;
}

.focus\\:border-\\[\\#1203501A\\]:focus {
  border-color: #1203501A !important;
}

.focus\\:border-ec-border:focus {
  --tw-border-opacity: 1 !important;
  border-color: rgb(235 235 235 / var(--tw-border-opacity, 1)) !important;
}

.focus\\:border-ec-primary:focus {
  --tw-border-opacity: 1 !important;
  border-color: rgb(115 81 253 / var(--tw-border-opacity, 1)) !important;
}

.focus\\:border-ec-secondary:focus {
  border-color: #7351FDCC !important;
}

.focus\\:\\!bg-ec-primary:focus {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(115 81 253 / var(--tw-bg-opacity, 1)) !important;
}

.focus\\:bg-\\[\\#F8F8F8\\]:focus {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(248 248 248 / var(--tw-bg-opacity, 1)) !important;
}

.focus\\:bg-ec-accent:focus {
  background-color: #7351FD0D !important;
}

.focus\\:bg-ec-primary:focus {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(115 81 253 / var(--tw-bg-opacity, 1)) !important;
}

.focus\\:bg-ec-secondary:focus {
  background-color: #7351FDCC !important;
}

.focus\\:bg-white:focus {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}

.focus\\:text-\\[\\#737791\\]:focus {
  --tw-text-opacity: 1 !important;
  color: rgb(115 119 145 / var(--tw-text-opacity, 1)) !important;
}

.focus\\:text-ec-body:focus {
  --tw-text-opacity: 1 !important;
  color: rgb(60 60 66 / var(--tw-text-opacity, 1)) !important;
}

.focus\\:text-ec-placeholder:focus {
  --tw-text-opacity: 1 !important;
  color: rgb(155 155 181 / var(--tw-text-opacity, 1)) !important;
}

.focus\\:text-ec-primary:focus {
  --tw-text-opacity: 1 !important;
  color: rgb(115 81 253 / var(--tw-text-opacity, 1)) !important;
}

.focus\\:text-ec-secondary:focus {
  color: #7351FDCC !important;
}

.focus\\:text-ec-title:focus {
  --tw-text-opacity: 1 !important;
  color: rgb(18 18 22 / var(--tw-text-opacity, 1)) !important;
}

.focus\\:text-white:focus {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.focus\\:shadow-none:focus {
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}

.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus\\:\\[box-shadow\\:0_0_0_4px_\\#F3F0FF\\]:focus {
  box-shadow: 0 0 0 4px #F3F0FF !important;
}

.active\\:bg-ec-primary:active {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(115 81 253 / var(--tw-bg-opacity, 1)) !important;
}

.active\\:text-ec-placeholder:active {
  --tw-text-opacity: 1 !important;
  color: rgb(155 155 181 / var(--tw-text-opacity, 1)) !important;
}

.active\\:text-ec-primary:active {
  --tw-text-opacity: 1 !important;
  color: rgb(115 81 253 / var(--tw-text-opacity, 1)) !important;
}

.active\\:text-ec-secondary:active {
  color: #7351FDCC !important;
}

.active\\:text-ec-title:active {
  --tw-text-opacity: 1 !important;
  color: rgb(18 18 22 / var(--tw-text-opacity, 1)) !important;
}

.active\\:text-white:active {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.active\\:shadow-none:active {
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.active\\:outline-none:active {
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed !important;
}

.disabled\\:bg-ec-table-stock:disabled {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(240 237 251 / var(--tw-bg-opacity, 1)) !important;
}

.disabled\\:hover\\:border-ec-table-stock:hover:disabled {
  --tw-border-opacity: 1 !important;
  border-color: rgb(240 237 251 / var(--tw-border-opacity, 1)) !important;
}

.disabled\\:focus\\:border-ec-table-stock:focus:disabled {
  --tw-border-opacity: 1 !important;
  border-color: rgb(240 237 251 / var(--tw-border-opacity, 1)) !important;
}

.group\\/coupons:hover .group-hover\\/coupons\\:visible {
  visibility: visible !important;
}

.group:hover .group-hover\\:visible {
  visibility: visible !important;
}

.group\\/coupons:hover .group-hover\\/coupons\\:top-0 {
  top: 0px !important;
}

.group\\/transaction:hover .group-hover\\/transaction\\:top-4 {
  top: 1rem !important;
}

.group:hover .group-hover\\:top-0 {
  top: 0px !important;
}

.group:hover .group-hover\\:top-4 {
  top: 1rem !important;
}

.group:hover .group-hover\\:block {
  display: block !important;
}

.group:hover .group-hover\\:hidden {
  display: none !important;
}

.group\\/coupons:hover .group-hover\\/coupons\\:translate-y-0 {
  --tw-translate-y: 0px !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.group:hover .group-hover\\:translate-y-0 {
  --tw-translate-y: 0px !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.group:hover .group-hover\\:border-ec-red {
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 58 82 / var(--tw-border-opacity, 1)) !important;
}

.group:hover .group-hover\\:bg-ec-red {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 58 82 / var(--tw-bg-opacity, 1)) !important;
}

.group:hover .group-hover\\:fill-ec-primary {
  fill: #7351FD !important;
}

.group:hover .group-hover\\:fill-ec-red {
  fill: #FF3A52 !important;
}

.group:hover .group-hover\\:fill-white {
  fill: #fff !important;
}

.group:hover .group-hover\\:text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.group\\/coupons:hover .group-hover\\/coupons\\:opacity-100 {
  opacity: 1 !important;
}

.group\\/transaction:hover .group-hover\\/transaction\\:opacity-100 {
  opacity: 1 !important;
}

.group:hover .group-hover\\:opacity-100 {
  opacity: 1 !important;
}

@media (max-width: 1200px) {

  .max-\\[1200px\\]\\:w-1\\/2 {
    width: 50% !important;
  }

  .max-\\[1200px\\]\\:w-\\[170px\\] {
    width: 170px !important;
  }

  .max-\\[1200px\\]\\:gap-3 {
    gap: 0.75rem !important;
  }

  .max-\\[1200px\\]\\:gap-\\[10px\\] {
    gap: 10px !important;
  }
}

@media (min-width: 640px) {

  .sm\\:mt-\\[50px\\] {
    margin-top: 50px !important;
  }

  .sm\\:w-\\[620px\\] {
    width: 620px !important;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .sm\\:flex-col {
    flex-direction: column !important;
  }

  .sm\\:gap-10 {
    gap: 2.5rem !important;
  }

  .sm\\:p-\\[30px\\] {
    padding: 30px !important;
  }

  .sm\\:px-10 {
    padding-left: 2.5rem !important;
    padding-right: 2.5rem !important;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }

  .sm\\:py-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .sm\\:py-\\[60px\\] {
    padding-top: 60px !important;
    padding-bottom: 60px !important;
  }

  .sm\\:\\!text-2xl {
    font-size: 1.5rem !important;
    line-height: 2rem !important;
  }

  .sm\\:text-sm {
    font-size: 0.875rem !important;
    line-height: 1.25rem !important;
  }
}

@media (min-width: 768px) {

  .md\\:mb-5 {
    margin-bottom: 1.25rem !important;
  }

  .md\\:mb-\\[30px\\] {
    margin-bottom: 30px !important;
  }

  .md\\:w-\\[12\\%\\] {
    width: 12% !important;
  }

  .md\\:w-\\[14\\%\\] {
    width: 14% !important;
  }

  .md\\:w-\\[16\\%\\] {
    width: 16% !important;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .md\\:flex-col {
    flex-direction: column !important;
  }

  .md\\:p-7 {
    padding: 1.75rem !important;
  }

  .md\\:p-\\[30px\\] {
    padding: 30px !important;
  }

  .md\\:\\!text-xl {
    font-size: 1.25rem !important;
    line-height: 1.75rem !important;
  }

  .md\\:text-\\[14px\\] {
    font-size: 14px !important;
  }

  .md\\:text-base {
    font-size: 1rem !important;
    line-height: 1.5rem !important;
  }

  .md\\:text-lg {
    font-size: 1.125rem !important;
    line-height: 1.75rem !important;
  }

  .md\\:text-sm {
    font-size: 0.875rem !important;
    line-height: 1.25rem !important;
  }

  .md\\:text-xl {
    font-size: 1.25rem !important;
    line-height: 1.75rem !important;
  }

  .md\\:text-xs {
    font-size: 0.75rem !important;
    line-height: 1rem !important;
  }

  .md\\:leading-\\[26px\\] {
    line-height: 26px !important;
  }
}

@media (min-width: 874px) {

  .ec-db-md\\:w-\\[268px\\] {
    width: 268px !important;
  }

  .ec-db-md\\:w-\\[calc\\(100\\%_-_268px\\)\\] {
    width: calc(100% - 268px) !important;
  }

  .ec-db-md\\:flex-row {
    flex-direction: row !important;
  }
}

@media (min-width: 1024px) {

  .lg\\:mr-4 {
    margin-right: 1rem !important;
  }

  .lg\\:w-\\[10\\%\\] {
    width: 10% !important;
  }

  .lg\\:w-\\[12\\%\\] {
    width: 12% !important;
  }

  .lg\\:w-\\[13\\%\\] {
    width: 13% !important;
  }

  .lg\\:w-\\[14\\%\\] {
    width: 14% !important;
  }

  .lg\\:w-\\[15\\%\\] {
    width: 15% !important;
  }

  .lg\\:w-\\[16\\%\\] {
    width: 16% !important;
  }

  .lg\\:w-\\[17\\%\\] {
    width: 17% !important;
  }

  .lg\\:w-\\[20\\%\\] {
    width: 20% !important;
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }

  .lg\\:flex-col {
    flex-direction: column !important;
  }

  .lg\\:justify-between {
    justify-content: space-between !important;
  }

  .lg\\:p-7 {
    padding: 1.75rem !important;
  }

  .lg\\:text-\\[14px\\] {
    font-size: 14px !important;
  }

  .lg\\:text-base {
    font-size: 1rem !important;
    line-height: 1.5rem !important;
  }

  .lg\\:text-sm {
    font-size: 0.875rem !important;
    line-height: 1.25rem !important;
  }

  .lg\\:text-xl {
    font-size: 1.25rem !important;
    line-height: 1.75rem !important;
  }
}

@media (min-width: 1200px) {

  .min-\\[1200px\\]\\:col-span-4 {
    grid-column: span 4 / span 4 !important;
  }

  .min-\\[1200px\\]\\:col-span-8 {
    grid-column: span 8 / span 8 !important;
  }
}

@media (min-width: 1280px) {

  .xl\\:col-span-6 {
    grid-column: span 6 / span 6 !important;
  }

  .xl\\:w-1\\/2 {
    width: 50% !important;
  }

  .xl\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .xl\\:flex-row {
    flex-direction: row !important;
  }

  .xl\\:items-center {
    align-items: center !important;
  }
}

@media (min-width: 1400px) {

  .min-\\[1400px\\]\\:w-\\[320px\\] {
    width: 320px !important;
  }
}

@media (min-width: 1440px) {

  .min-\\[1440px\\]\\:w-\\[190px\\] {
    width: 190px !important;
  }

  .min-\\[1440px\\]\\:w-\\[210px\\] {
    width: 210px !important;
  }

  .min-\\[1440px\\]\\:w-\\[452px\\] {
    width: 452px !important;
  }
}

@media (min-width: 1500px) {

  .min-\\[1500px\\]\\:w-\\[10\\%\\] {
    width: 10% !important;
  }

  .min-\\[1500px\\]\\:w-\\[20\\%\\] {
    width: 20% !important;
  }

  .min-\\[1500px\\]\\:flex-row {
    flex-direction: row !important;
  }

  .min-\\[1500px\\]\\:items-center {
    align-items: center !important;
  }
}

@media (min-width: 1536px) {

  .\\32xl\\:w-1\\/4 {
    width: 25% !important;
  }

  .\\32xl\\:w-2\\/4 {
    width: 50% !important;
  }

  .\\32xl\\:flex-row {
    flex-direction: row !important;
  }
}

@media (min-width: 1700px) {

  .min-\\[1700px\\]\\:col-span-3 {
    grid-column: span 3 / span 3 !important;
  }

  .min-\\[1700px\\]\\:col-span-6 {
    grid-column: span 6 / span 6 !important;
  }

  .min-\\[1700px\\]\\:text-center {
    text-align: center !important;
  }
}

.\\[\\&\\:\\:-webkit-calendar-picker-indicator\\]\\:cursor-pointer::-webkit-calendar-picker-indicator {
  cursor: pointer !important;
}

.\\[\\&\\:\\:-webkit-calendar-picker-indicator\\]\\:opacity-0::-webkit-calendar-picker-indicator {
  opacity: 0 !important;
}

.\\[\\&\\:\\:-webkit-color-swatch-wrapper\\]\\:p-\\[px\\]::-webkit-color-swatch-wrapper {
  padding: px !important;
}

.\\[\\&\\:\\:-webkit-color-swatch\\]\\:rounded-\\[4px\\]::-webkit-color-swatch {
  border-radius: 4px !important;
}

.\\[\\&\\:\\:-webkit-color-swatch\\]\\:border-0::-webkit-color-swatch {
  border-width: 0px !important;
}`, "",{"version":3,"sources":["webpack://./assets/common/css/tailwind.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,6BAAc;EAAd,gCAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,yBAAc;EAAd,wBAAc;EAAd,+BAAc;EAAd,uBAAc;EAAd,4BAAc;EAAd,yBAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,+BAAc;EAAd,+BAAc;EAAd,8BAAc;EAAd,2BAAc;EAAd,2BAAc;EAAd,+BAAc;EAAd,8BAAc;EAAd,4BAAc;EAAd,0BAAc;EAAd,4BAAc;EAAd,2BAAc;EAAd,+BAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,4BAAc;EAAd,gCAAc;EAAd,6BAAc;EAAd,6BAAc;EAAd,iCAAc;EAAd,6BAAc;EAAd,6BAAc;EAAd,iCAAc;EAAd,iCAAc;EAAd,iCAAc;EAAd,qCAAc;EAAd,+BAAc;EAAd,+BAAc;EAAd,mCAAc;EAAd,kCAAc;EAAd,kCAAc;EAAd,sCAAc;EAAd,gCAAc;EAAd,gCAAc;EAAd,oCAAc;EAAd,iCAAc;EAAd,iCAAc;EAAd,qCAAc;EAAd,8BAAc;EAAd,8BAAc;EAAd,kCAAc;EAAd,gCAAc;EAAd,gCAAc;EAAd,oCAAc;EAAd,2CAAc;EAAd,2CAAc;EAAd,+CAAc;EAAd,+BAAc;EAAd,+BAAc;EAAd,mCAAc;EAAd,gCAAc;EAAd,gCAAc;EAAd,oCAAc;EAAd,oCAAc;EAAd,oCAAc;EAAd,wCAAc;EAAd,iCAAc;EAAd,iCAAc;EAAd,qCAAc;EAAd,qCAAc;EAAd,qCAAc;EAAd,yCAAc;EAAd,kCAAc;EAAd,kCAAc;EAAd,sCAAc;EAAd,iCAAc;EAAd,iCAAc;EAAd,qCAAc;EAAd,+BAAc;EAAd,+BAAc;EAAd,mCAAc;EAAd,8BAAc;EAAd,8BAAc;EAAd,kCAAc;EAAd,kCAAc;EAAd,kCAAc;EAAd,sCAAc;EAAd,+BAAc;EAAd,+BAAc;EAAd,mCAAc;EAAd,iCAAc;EAAd,iCAAc;EAAd,qCAAc;EAAd,8BAAc;EAAd,8BAAc;EAAd,kCAAc;EAAd,gCAAc;EAAd,gCAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,+BAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;KAAnB,gCAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,yEAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,uEAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,yEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;KAAnB;AAAmB;AAAnB;EAAA,+BAAmB;KAAnB;AAAmB;AAAnB;EAAA,8BAAmB;KAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2DAAmB;EAAnB,wEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wFAAmB;EAAnB,4GAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,oDAAmB;EAAnB,yEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oDAAmB;EAAnB,yEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qDAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,0RAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,0RAAmB;EAAnB;AAAmB;AAAnB;EAAA,2KAAmB;EAAnB,mKAAmB;EAAnB,4LAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0GAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB,YAAY;AACZ;IACI,kBAAkB;IAClB,UAAU;IACV,uBAC2D;IAD3D,kBAC2D;IAD3D,gBAC2D;IAD3D,kBAC2D;IAD3D,kBAC2D;IAD3D,2DAC2D;IAD3D,iBAC2D;IAD3D,oBAC2D;IAD3D,gCAC2D;IAD3D,eAC2D;IAD3D,iBAC2D;IAD3D,oBAC2D;IAD3D,mDAC2D;IAD3D,0BAC2D;AAC/D;AAFI;EAAA,kBAC2D;EAD3D;AAC2D;;AAG/D;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB,6DAA6D;IAC7D;;iCAE6B;IAC7B,2BAA2B;IAC3B,uBAAuB;IACvB,WAAW;AACf;;AAGI;EAAA,mBACiG;EADjG,aACiG;EADjG,cACiG;EADjG,uBACiG;EADjG,kBACiG;EADjG,mBACiG;EADjG,uBACiG;EADjG,iBACiG;EADjG,mBACiG;EADjG,sBACiG;EADjG,2DACiG;EADjG,6BACiG;EADjG,kBACiG;EADjG,mBACiG;EADjG,gCACiG;EADjG,eACiG;EADjG,iBACiG;EADjG,oBACiG;EADjG,kDACiG;EADjG;AACiG;;AADjG;EAAA,kBACiG;EADjG,2DACiG;EADjG,oBACiG;EADjG;AACiG;AAGjG;EAAA,uBAAkN;EAAlN,kBAAkN;EAAlN,wBAAkN;EAAlN,mBAAkN;EAAlN,sBAAkN;EAAlN,yDAAkN;EAAlN,mBAAkN;EAAlN,sBAAkN;EAAlN,gCAAkN;EAAlN,eAAkN;EAAlN,iBAAkN;EAAlN,oBAAkN;EAAlN,gDAAkN;EAAlN;AAAkN;AAAlN;EAAA,sBAAkN;EAAlN,2DAAkN;EAAlN,oBAAkN;EAAlN;AAAkN;AAAlN;EAAA,oBAAkN;EAAlN,kDAAkN;EAAlN,sBAAkN;EAAlN,8BAAkN;EAAlN;AAAkN;AAGlN;EAAA,aAA4K;EAA5K,cAA4K;EAA5K,aAA4K;EAA5K,mBAA4K;EAA5K,uBAA4K;EAA5K,qBAA4K;EAA5K,iBAA4K;EAA5K,mBAA4K;EAA5K,sBAA4K;EAA5K,4DAA4K;EAA5K,2BAA4K;EAA5K;AAA4K;AAA5K;EAAA,sBAA4K;EAA5K,0DAA4K;EAA5K,kBAA4K;EAA5K;AAA4K;;AAGhL,WAAW;AAEP;EAAA,sBAA0B;EAA1B,kBAA0B;EAA1B;AAA0B;AAG1B;EAAA,aAAuD;EAAvD,mBAAuD;EAAvD,8BAAuD;EAAvD,iBAAuD;EAAvD,oBAAuD;EAAvD,oBAAuD;EAAvD,qBAAuD;IACvD;AADuD;AAIvD;EAAA,aAAsC;EAAtC,YAAsC;EAAtC,mBAAsC;EAAtC;AAAsC;AAGtC;EAAA,gCAAkE;EAAlE,iBAAkE;EAAlE,iBAAkE;EAAlE,gBAAkE;EAAlE,iBAAkE;EAAlE,oBAAkE;EAAlE;AAAkE;AAGlE;EAAA,kBAAgC;EAAhC;AAAgC;AAGhC;EAAA,eAAU;IACV;AADU;AAIV;EAAA,aAAgB;EAAhB;AAAgB;AAGhB;EAAA,aAAuE;EAAvE,YAAuE;EAAvE,WAAuE;EAAvE,mBAAuE;EAAvE,uBAAuE;EAAvE,qBAAuE;EAAvE,kBAAuE;EAAvE,4DAAuE;EAAvE,eAAuE;IACvE;AADuE;CAG1E;IACG,6DAA6D;IAC7D,YAAY;AAChB;CACC;IACG,6DAA6D;IAC7D,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,YAAY;AAChB;;AAEA,iBAAiB;AAEb;EAAA,qBAA2D;EAA3D,aAA2D;EAA3D,gCAA2D;EAA3D,eAA2D;EAA3D,iBAA2D;IAC3D;AAD2D;AAI3D;EAAA,oBAA0B;EAA1B;AAA0B;AAA1B;EAAA,oBAA0B;EAA1B;AAA0B;AAG1B;EAAA,sBAAwB;EAAxB,2DAAwB;IACxB;AADwB;AAIxB;EAAA,sBAAwB;EAAxB,2DAAwB;IACxB,kCAAkC;IAClC;AAFwB;;AAMxB;EAAA,qBAAoD;EAApD,iBAAoD;EAApD,sBAAoD;EAApD,2DAAoD;EAApD;AAAoD;;AAIpD;EAAA,kBAA8B;EAA9B,2DAA8B;EAA9B,oBAA8B;EAA9B;AAA8B;;AAI9B;EAAA,sBAAyC;EAAzC,mBAAyC;EAAzC,oBAAyC;EAAzC,gBAAyC;EAAzC,oBAAyC;EAAzC;AAAyC;;AAIzC;EAAA,sBAAmB;EAAnB,4DAAmB;IACnB;AADmB;;AAKnB;EAAA,oBAAgB;EAAhB;AAAgB;;AAGpB;IACI,QAAQ;AACZ;;AAGI;EAAA,oBAAkB;EAAlB;AAAkB;;AAIlB;EAAA,oBAAiB;EAAjB;AAAiB;;AAGrB;IACI,aAAa;IACb,cAAc;AAClB;;AAGI;EAAA,kBAAuB;EAAvB;AAAuB;;AAG3B;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAGI;EAAA,kBAAuB;EAAvB;AAAuB;;AAlK3B;EAAA,0BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,0BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,8BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,8BAmKC;EAnKD;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA,+BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,+BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,qCAmKC;EAnKD;AAmKC;;AAnKD;EAAA,qCAmKC;EAnKD;AAmKC;;AAnKD;EAAA,qCAmKC;EAnKD;AAmKC;;AAnKD;EAAA,qCAmKC;EAnKD;AAmKC;;AAnKD;EAAA,qCAmKC;EAnKD;AAmKC;;AAnKD;EAAA,qCAmKC;EAnKD,6BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,yCAmKC;EAnKD;AAmKC;;AAnKD;EAAA,0CAmKC;EAnKD;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA,6BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,6BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,6BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,+BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,+BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,iCAmKC;EAnKD;AAmKC;;AAnKD;EAAA,yCAmKC;EAnKD;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA,4BAmKC;EAnKD,4BAmKC;EAnKD;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA,iCAmKC;EAnKD;AAmKC;;AAnKD;EAAA,iCAmKC;EAnKD;AAmKC;;AAnKD;EAAA,iCAmKC;EAnKD;AAmKC;;AAnKD;EAAA,iCAmKC;EAnKD;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA,6BAmKC;EAnKD;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA,6BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,6BAmKC;EAnKD;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA,6BAmKC;EAnKD;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA,6BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,6BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,6BAmKC;EAnKD;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA,6BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,6BAmKC;EAnKD;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA,6BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,6BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,6BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,+BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,+BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,+BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,+BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,+BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,+BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,+BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,+BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,+BAmKC;EAnKD;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA,+BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,+BAmKC;EAnKD;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA,+BAmKC;EAnKD;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA,kDAmKC;EAnKD,uEAmKC;EAnKD;AAmKC;;AAnKD;EAAA,kDAmKC;EAnKD,uEAmKC;EAnKD;AAmKC;;AAnKD;EAAA,mDAmKC;EAnKD,0EAmKC;EAnKD;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA,iCAmKC;EAnKD;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA,iCAmKC;EAnKD;AAmKC;;AAnKD;EAAA,iCAmKC;EAnKD;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA,6BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,6BAmKC;EAnKD;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA,6BAmKC;EAnKD;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA,6BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,+BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,+BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,+BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,+BAmKC;EAnKD;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA,+BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,+BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,iCAmKC;EAnKD,yCAmKC;EAnKD;AAmKC;;AAnKD;EAAA,yCAmKC;EAnKD;AAmKC;;AAnKD;EAAA,sHAmKC;EAnKD,oHAmKC;EAnKD;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA,6BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,+BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,+BAmKC;EAnKD;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA,+BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,+BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,iCAmKC;EAnKD,yCAmKC;EAnKD;AAmKC;;AAnKD;EAAA,yCAmKC;EAnKD;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA,6BAmKC;EAnKD;AAmKC;;AAnKD;EAAA,iCAmKC;EAnKD;AAmKC;;AAnKD;EAAA,iCAmKC;EAnKD;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA,gCAmKC;EAnKD;AAmKC;;AAnKD;EAAA,gCAmKC;EAnKD;AAmKC;;AAnKD;EAAA,iCAmKC;EAnKD;AAmKC;;AAnKD;EAAA,6BAmKC;EAnKD;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA,+BAmKC;EAnKD;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;;EAAA;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;AAAA;;AAnKD;;EAAA;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA,+BAmKC;IAnKD;EAmKC;;EAnKD;IAAA,+BAmKC;IAnKD;EAmKC;;EAnKD;IAAA,4BAmKC;IAnKD;EAmKC;;EAnKD;IAAA,4BAmKC;IAnKD;EAmKC;;EAnKD;IAAA,4BAmKC;IAnKD;EAmKC;;EAnKD;IAAA,8BAmKC;IAnKD;EAmKC;AAAA;;AAnKD;;EAAA;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA,6BAmKC;IAnKD;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA,0BAmKC;IAnKD;EAmKC;;EAnKD;IAAA,8BAmKC;IAnKD;EAmKC;;EAnKD;IAAA,8BAmKC;IAnKD;EAmKC;;EAnKD;IAAA,6BAmKC;IAnKD;EAmKC;;EAnKD;IAAA,6BAmKC;IAnKD;EAmKC;;EAnKD;IAAA;EAmKC;AAAA;;AAnKD;;EAAA;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;AAAA;;AAnKD;;EAAA;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA,0BAmKC;IAnKD;EAmKC;;EAnKD;IAAA,8BAmKC;IAnKD;EAmKC;;EAnKD;IAAA,6BAmKC;IAnKD;EAmKC;AAAA;;AAnKD;;EAAA;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;AAAA;;AAnKD;;EAAA;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;AAAA;;AAnKD;;EAAA;IAAA;EAmKC;AAAA;;AAnKD;;EAAA;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;AAAA;;AAnKD;;EAAA;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;AAAA;;AAnKD;;EAAA;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;AAAA;;AAnKD;;EAAA;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;;EAnKD;IAAA;EAmKC;AAAA;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC;;AAnKD;EAAA;AAmKC","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* buttons */\n.easycommerce-primary-button {\n    position: relative;\n    z-index: 1;\n    @apply bg-ec-primary hover:bg-[#6640FF] duration-300 text-white rounded-[8px] py-[11px]\n    font-inter text-[16px] leading-[20px] w-max overflow-hidden;\n}\n\n.easycommerce-primary-button::before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    padding: 2px;\n    border-radius: 8px;\n    background: linear-gradient(180deg, #8466FF 0%, #643DFF 100%);\n    -webkit-mask: \n        linear-gradient(#fff 0 0) content-box, \n        linear-gradient(#fff 0 0);\n    -webkit-mask-composite: xor;\n    mask-composite: exclude;\n    z-index: -1;\n}\n\n.easycommerce-outline-button {\n    @apply bg-transparent hover:bg-ec-primary duration-300 text-ec-primary hover:text-white rounded-md flex items-center px-4\n    font-inter text-[16px] leading-[20px] w-max border-[1px] border-solid border-ec-primary h-10 mt-3;\n}\n.easycommerce-underline-button {\n    @apply text-ec-body focus:text-ec-primary hover:text-ec-primary py-2 font-inter text-[16px] leading-[20px] w-max border-b-[1px] border-solid border-ec-body hover:border-ec-primary duration-300 focus:shadow-none;\n}\n.easycommerce-delete-button {\n    @apply rounded-full w-6 h-6 border-[1px] border-solid border-[#F0EDFB] bg-[#7351FD08] flex items-center justify-center hover:border-[#FF3A52] hover:bg-[#FF3A52] duration-300\n}\n\n/* Panels */\n.easycommerce-product-section {\n    @apply bg-white rounded-xl;\n}\n.product-panel-heading {\n    @apply py-[14px] px-6 flex items-center justify-between;\n    border-bottom: 1px solid #F0EDFB;\n}\n.product-panel-title {\n    @apply flex items-center gap-3 h-[41px]\n}\n.product-panel-title h3 {\n    @apply font-inter text-2xl font-medium text-ec-title leading-[38px]\n}\n.product-panel-title button.panel-info {\n    @apply border-none bg-transparent\n}\n.product-panel-body {\n    @apply p-6;\n    transition: 0.3s\n}\n.panel-actions {\n    @apply flex gap-2\n}\n.panel-actions button {\n    @apply rounded-lg p-2 w-8 h-8 flex items-center justify-center bg-white;\n    border: 1px solid #F0EDFB;\n}\n button.ai-generate {\n    background: linear-gradient(180deg, #7351FD 0%, #A33BFF 100%);\n    border: none;\n}\n button.ai-generate:hover {\n    background: linear-gradient(180deg, #A33BFF 0%, #7351FD 100%);\n    transition: 0.3s;\n}\n.panel-actions button.panel-drag {\n    cursor: move;\n}\n.panel-actions button.panel-collapse svg {\n    transition: 0.3s;\n}\n.panel-actions button.panel-collapse.collapsed svg {\n    transform: rotate(180deg);\n    transition: 0.3s;\n}\n.easycommerce-product-section.collapsed .product-panel-body {\n    padding-top: 0;\n    padding-bottom: 0;\n    transition: 0.3s;\n}\n.easycommerce-product-section.collapsed .product-panel-body * {\n    display: none;\n}\n.easycommerce-product-section.collapsed .product-panel-heading {\n    border: none;\n}\n\n/* Input fields */\n.easycommerce-product-section :is(input, textarea) {\n    @apply p-4 rounded-lg font-inter text-[14px] leading-[20px];\n    border: 1px solid #F0EDFB;\n}\n.easycommerce-product-section :is(input, textarea)::placeholder {\n    @apply text-ec-placeholder;\n}\n.easycommerce-product-section :is(input, textarea):hover {\n    @apply border-ec-primary;\n    transition: border-color 0.3s ease;\n}\n.easycommerce-product-section :is(input, textarea):focus {\n    @apply border-ec-primary;\n    transition: border-color 0.3s ease;\n    box-shadow: 0 0 0 4px #F3F0FF;\n}\n\n.easycommerce-datepicker-container .react-datepicker {\n    @apply rounded-lg border border-ec-primary font-inter\n}\n\n.easycommerce-datepicker-container .react-datepicker__header {\n    @apply bg-ec-primary text-white\n}\n\n.easycommerce-datepicker-container h2.react-datepicker__current-month {\n    @apply text-white text-sm font-medium mb-1\n}\n\n.easycommerce-datepicker-container .react-datepicker__navigation-icon::before {\n    @apply border-white;\n    border-width: 1px 1px 0 0;\n}\n\n.easycommerce-datepicker-container .react-datepicker__day-name {\n    @apply text-white\n}\n\n.easycommerce-datepicker-container .react-datepicker__navigation {\n    top: 4px;\n}\n\n.easycommerce-datepicker-container .react-datepicker__day {\n    @apply text-ec-body\n}\n\n.easycommerce-datepicker-container .react-datepicker__day--outside-month {\n    @apply text-[#bbb]\n}\n\n.easycommerce-datepicker-container .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {\n    fill: #7351FD;\n    color: #7351FD;\n}\n\n.easycommerce-datepicker-container :is(.react-datepicker__day--selected:not([aria-disabled=true]):hover, .react-datepicker__day--in-selecting-range:not([aria-disabled=true]):hover, .react-datepicker__day--in-range:not([aria-disabled=true]):hover, .react-datepicker__month-text--selected:not([aria-disabled=true]):hover, .react-datepicker__month-text--in-selecting-range:not([aria-disabled=true]):hover, .react-datepicker__month-text--in-range:not([aria-disabled=true]):hover, .react-datepicker__quarter-text--selected:not([aria-disabled=true]):hover, .react-datepicker__quarter-text--in-selecting-range:not([aria-disabled=true]):hover, .react-datepicker__quarter-text--in-range:not([aria-disabled=true]):hover, .react-datepicker__year-text--selected:not([aria-disabled=true]):hover, .react-datepicker__year-text--in-selecting-range:not([aria-disabled=true]):hover, .react-datepicker__year-text--in-range:not([aria-disabled=true]):hover, .react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range, .react-datepicker__month-text--selected, .react-datepicker__month-text--in-selecting-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--selected, .react-datepicker__quarter-text--in-selecting-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--selected, .react-datepicker__year-text--in-selecting-range, .react-datepicker__year-text--in-range) {\n    @apply bg-ec-table-stock\n}\n\n.ec-product-status-dropdown button {\n    color: #7351FD !important;\n    border-color: #7351FD !important;\n}\n\n.easycommerce-datepicker-container .react-datepicker__day--keyboard-selected, .react-datepicker__month-text--keyboard-selected, .react-datepicker__quarter-text--keyboard-selected, .react-datepicker__year-text--keyboard-selected {\n    @apply bg-ec-table-stock\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
